<template>
  <div class="profile-container">

    <div class="con-box">
      <div class="sidebar-header">
        <img class="header-icon" :src="require('@/assets/image/my/my.png')" :alt="profileCenterTitle">
        <span class="header-title">{{ profileCenterTitle }}</span>
      </div>
      <div class="profile-wrapper">
        <!-- 左侧导航 -->
        <div class="profile-sidebar">
          <div class="user-info">
            <img class="user-avatar" :src="getAvatarUrl(userInfo.avatar)" alt="头像">
            <div style="display: flex; align-items: center;">
              <div class="user-name">{{ userInfo.nickname || userInfo.name }}</div>
              <presence-selector variant="sidebar" />
            </div>
          </div>

          <div class="sidebar-menu">
            <div
              v-for="(item, index) in filteredMenuItems"
              :key="index"
              class="menu-item"
              :class="{ active: activeMenu === item.key && activeMenu !== '16' && activeMenu !== '17' }"
              @click="handleMenuClick(item.key)"
            >
              <img
                class="menu-icon"
                :src="getMenuIcon(item.key)"
                :alt="item.label"
              >
              <span class="menu-label">{{ item.label }}</span>
              <img
                v-if="item.key === '11'"
                class="expand-icon"
                :class="{ expanded: settingsExpanded }"
                :src="require('@/assets/image/my/xia.png')"
                alt="展开"
              >
            </div>

            <!-- 设置展开选项 -->
            <div v-if="settingsExpanded" class="settings-options">
              <div
                class="settings-option"
                :class="{ 'active-option': activeSettingsOption === 'phone' }"
                @click="changePhone"
              >
                更换手机号
              </div>
              <!-- <div
                class="settings-option"
                :class="{ 'active-option': activeSettingsOption === 'email' }"
                @click="changeEmail"
              >
                更换邮箱
              </div> -->
              <div
                class="settings-option"
                :class="{ 'active-option': activeSettingsOption === 'deregister' }"
                @click="deregisterAccount"
              >
                注销账号
              </div>
              <div
                class="settings-option"
                :class="{ 'active-option': activeSettingsOption === 'logout' }"
                @click="logout"
              >
                退出登录
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧内容区 -->
        <div class="profile-content">
          <!-- 个人资料 -->
          <div v-if="activeMenu === '1'" class="content-section">
            <div class="section-title">个人头像</div>
            <div class="avatar-section">
              <img class="current-avatar" :src="getAvatarUrl(userInfo.avatar)" alt="当前头像">
              <el-button type="primary" class="upload-btn" :loading="avatarUploading" @click="triggerAvatarUpload">
                {{ avatarUploading ? '上传中...' : '上传头像' }}
              </el-button>
              <input
                ref="avatarInput"
                type="file"
                accept="image/*"
                style="display: none"
                @change="handleAvatarChange"
              >
            </div>

            <div class="verification-section">
              <div class="verification-row">
                <img class="shield-icon" :src="require('@/assets/image/al/yk.png')" alt="认证">
                <span class="user-status">{{ userInfo.user_type }}</span>
              </div>
              <div class="verification-row">
                <span class="verification-text">实名认证</span>
                <span class="verification-status" :class="getRealNameStatusClass()">
                  {{ getRealNameStatusText() }}
                </span>
                <a
                  v-if="realNameStatus.status_code === -1"
                  href="#"
                  class="verify-link"
                  @click.prevent="goToShiming"
                >
                  立即认证>
                </a>
              </div>
            </div>

            <div class="form-section">
              <div class="form-item">
                <label class="form-label">个人名称</label>
                <el-input v-model="userInfo.nickname" placeholder="请输入个人名称" />
              </div>
              <div class="form-item">
                <label class="form-label">手机号码</label>
                <el-input v-model="userInfo.phone" disabled placeholder="请输入手机号码" />
              </div>
              <!-- <div class="form-item">
                <label class="form-label">身份证号</label>
                <el-input v-model="userInfo.idCard" placeholder="请输入身份证号" />
              </div> -->
              <div class="form-item">
                <label class="form-label">账号存在时间</label>
                <el-input v-model="userInfo.accountTime" disabled placeholder="账号存在时间" />
              </div>
            </div>

            <!-- 资质认证：跳转独立页面填写 -->
            <div v-if="showProfileEngineerCert || showProfileSupplierCert" class="profile-cert-entries" style="margin-bottom: 30px;">
              <div class="section-title">资质认证</div>
              <div class="profile-cert-entry-row">
                <div
                  v-if="showProfileEngineerCert"
                  class="profile-cert-entry-card"
                  role="button"
                  tabindex="0"
                  @click="goCostEngineerCertification"
                  @keyup.enter="goCostEngineerCertification"
                >
                  <div class="profile-cert-entry-icon-wrap">
                    <i class="el-icon-user-solid profile-cert-entry-icon" />
                  </div>
                  <div class="profile-cert-entry-text">
                    <div class="profile-cert-entry-title">造价师资质认证</div>
                    <div class="profile-cert-entry-desc">提交资料申请造价师资质</div>
                  </div>
                  <i class="el-icon-arrow-right profile-cert-entry-arrow" />
                </div>
                <div
                  v-if="showProfileSupplierCert"
                  class="profile-cert-entry-card"
                  role="button"
                  tabindex="0"
                  @click="goSupplierCertification"
                  @keyup.enter="goSupplierCertification"
                >
                  <div class="profile-cert-entry-icon-wrap supplier">
                    <i class="el-icon-office-building profile-cert-entry-icon" />
                  </div>
                  <div class="profile-cert-entry-text">
                    <div class="profile-cert-entry-title">供应商资质认证</div>
                    <div class="profile-cert-entry-desc">提交企业资料申请供应商资质</div>
                  </div>
                  <i class="el-icon-arrow-right profile-cert-entry-arrow" />
                </div>
              </div>
            </div>

            <!-- 用户身份升级入口（仅会员显示） -->
            <!-- <div v-if="userInfo.group_id === 1" class="upgrade-section">
              <div class="section-title">身份升级</div>
              <div class="upgrade-options">
                <div class="upgrade-card" @click="goToEngineerRegister">
                  <div class="upgrade-icon">
                    <i class="el-icon-user-solid" />
                  </div>
                  <div class="upgrade-content">
                    <div class="upgrade-title">申请成为造价师</div>
                    <div class="upgrade-desc">提交资质认证，成为专业造价师</div>
                  </div>
                  <div class="upgrade-arrow">
                    <i class="el-icon-arrow-right" />
                  </div>
                </div>
                <div class="upgrade-card" @click="goToSupplierRegister">
                  <div class="upgrade-icon">
                    <i class="el-icon-office-building" />
                  </div>
                  <div class="upgrade-content">
                    <div class="upgrade-title">申请成为供应商</div>
                    <div class="upgrade-desc">提交企业认证，成为供应商</div>
                  </div>
                  <div class="upgrade-arrow">
                    <i class="el-icon-arrow-right" />
                  </div>
                </div>
              </div>
            </div> -->

            <el-button type="primary" class="save-btn" @click="saveProfile">保存</el-button>
          </div>

          <!-- 造价问答中心 -->
          <div v-else-if="activeMenu === '2'" class="content-section qa-records-section">
            <div class="qa-center-toolbar">
              <el-button type="primary" class="qa-go-publish-btn" @click="goToCostqaPublish">
                去发布问题
              </el-button>
            </div>
            <div class="qa-records-tabs">
              <div class="qa-tab-item" :class="{ active: qaRecordTab === 'mypost' }" @click="switchQaRecordTab('mypost')">我的发布</div>
              <div class="qa-tab-item" :class="{ active: qaRecordTab === 'myanswer' }" @click="switchQaRecordTab('myanswer')">我的回答</div>
            </div>
            <div class="qa-records-content">
              <template v-if="qaRecordTab === 'mypost'">
                <div v-if="qaMyPosts.length > 0" class="my-post-list">
                  <div v-for="item in qaMyPosts" :key="item.id" class="my-post-item">
                    <div class="post-header">
                      <div class="post-title">{{ item.title }}</div>
                      <div class="post-category">{{ item.category_name }}</div>
                    </div>
                    <div class="post-content">{{ item.content }}</div>
                    <div v-if="item.images && item.images.length > 0" class="post-images">
                      <img v-for="(image, index) in item.images" :key="index" :src="getImageUrl(image)" alt="图片" class="post-image">
                    </div>
                    <div class="post-footer">
                      <div class="post-meta">
                        <span class="reward-amount">悬赏：¥{{ item.reward_amount }}</span>
                        <span class="answer-count">{{ item.answer_count }}个回答</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="empty-state">
                  <div class="empty-icon">📝</div>
                  <div class="empty-text">暂无发布的问题</div>
                </div>
                <div v-if="qaMyPostsTotal > 0 && qaMyPosts.length > 0" style="display:flex; justify-content:flex-end; margin-top: 12px;">
                  <el-pagination background layout="prev, pager, next" :total="qaMyPostsTotal" :current-page="qaMyPostsPage" :page-size="qaMyPostsLimit" @current-change="onQaMyPostsPageChange" />
                </div>
              </template>
              <template v-else>
                <div class="my-tabs">
                  <div v-for="t in qaMyAnswerTabs" :key="t.value" class="my-tab-item" :class="{ active: qaMyAnswerSubTab === t.value }" @click="onQaMyAnswerSubTabChange(t.value)">
                    {{ t.label }}
                  </div>
                </div>
                <div class="my-tab-content">
                  <div v-if="qaMyAnswerSubTab === 'answered'">
                    <div v-if="qaMyAnswers.length > 0" class="my-answers-list">
                      <div v-for="item in qaMyAnswers" :key="item.id" class="answer-item-card">
                        <div class="answer-card-header">
                          <div class="question-title">{{ item.question_title }}</div>
                          <div class="adopt-status" :class="{ adopted: item.is_adopted === 1 }">{{ item.is_adopted === 1 ? '已采纳' : '未采纳' }}</div>
                        </div>
                        <div class="answer-content">{{ item.content }}</div>
                        <div v-if="item.images && item.images.length > 0" class="answer-images">
                          <img v-for="(img, index) in item.images" :key="index" :src="getImageUrl(img)" alt="回答图片" class="answer-image">
                        </div>
                      </div>
                    </div>
                    <div v-else class="empty-state">
                      <div class="empty-icon">💬</div>
                      <div class="empty-text">暂无已回答的问题</div>
                    </div>
                    <div v-if="qaMyAnswersTotal > 0 && qaMyAnswers.length > 0" style="display:flex; justify-content:flex-end; margin-top: 12px;">
                      <el-pagination background layout="prev, pager, next" :total="qaMyAnswersTotal" :current-page="qaMyAnswersPage" :page-size="qaMyAnswersLimit" @current-change="onQaMyAnswersPageChange" />
                    </div>
                  </div>
                  <div v-else-if="qaMyAnswerSubTab === 'income'">
                    <div class="income-card">
                      <div class="income-title">问答收入</div>
                      <div class="income-total">¥{{ qaIncomeTotal }}</div>
                    </div>
                    <div class="income-list-wrap">
                      <div class="income-list-title">收入记录</div>
                      <div v-if="qaIncomeRecords.length > 0" class="income-list">
                        <div v-for="record in qaIncomeRecords" :key="record.id" class="income-item">
                          <div class="income-left">
                            <div class="income-name">{{ record.description }}</div>
                            <div class="income-question">问题：{{ record.question_title }}</div>
                            <div class="income-time">{{ record.createtime }}</div>
                          </div>
                          <div class="income-amount">+{{ record.amount }}</div>
                        </div>
                      </div>
                      <div v-else class="empty-state">
                        <div class="empty-icon">💰</div>
                        <div class="empty-text">暂无收入记录</div>
                      </div>
                      <div v-if="qaIncomeTotalCount > 0 && qaIncomeRecords.length > 0" style="display:flex; justify-content:flex-end; margin-top: 12px;">
                        <el-pagination background layout="prev, pager, next" :total="qaIncomeTotalCount" :current-page="qaIncomePage" :page-size="qaIncomeLimit" @current-change="onQaIncomePageChange" />
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="qaHistoryList.length > 0" class="history-list">
                      <div v-for="item in qaHistoryList" :key="item.id" class="history-item">
                        <div class="history-content">
                          <div class="history-title">{{ item.title }}</div>
                          <div class="history-meta">
                            <span class="history-type">{{ item.type === 'answer' ? '回答' : '问题' }}</span>
                            <span class="history-status" :class="{ adopted: item.is_adopted === 1 }">{{ item.is_adopted === 1 ? '已采纳' : '未采纳' }}</span>
                          </div>
                          <div class="history-time">{{ item.createtime }}</div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="empty-state">
                      <div class="empty-icon">📋</div>
                      <div class="empty-text">暂无历史记录</div>
                    </div>
                    <div v-if="qaHistoryTotal > 0 && qaHistoryList.length > 0" style="display:flex; justify-content:flex-end; margin-top: 12px;">
                      <el-pagination background layout="prev, pager, next" :total="qaHistoryTotal" :current-page="qaHistoryPage" :page-size="qaHistoryLimit" @current-change="onQaHistoryPageChange" />
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <!-- 我的余额 -->
          <div v-else-if="activeMenu === '3'" class="content-section balance-section">
            <!-- 余额头部 -->
            <div class="balance-header">
              <div class="balance-info">
                <div class="balance-label">我的余额</div>
                <div class="balance-amount">¥{{ userInfo.money || '0.00' }}</div>
              </div>
              <div class="balance-actions">
                <div v-if="showBalanceWithdraw" class="action-btn" @click="goToTixian">
                  提现 >
                </div>
                <div class="action-btn" @click="goToBill">
                  账单 >
                </div>
              </div>
            </div>

            <div
              v-if="showBalancePolicyLink"
              class="balance-policy-link"
              role="button"
              tabindex="0"
              @click="goToRechargePolicy"
              @keyup.enter="goToRechargePolicy"
            >
              <span>{{ balancePolicyLabel }}</span>
              <i class="el-icon-arrow-right" />
            </div>

            <template v-if="showBalanceRecharge">
              <!-- 充值金额选择 -->
              <div class="recharge-section">
                <div class="recharge-label">充值金额</div>
                <div class="amount-grid">
                  <div
                    v-for="amount in quickAmounts"
                    :key="amount"
                    class="amount-btn"
                    :class="{ active: rechargeAmount == amount }"
                    @click="selectQuickAmount(amount)"
                  >
                    {{ amount }}
                  </div>
                  <div
                    class="amount-btn custom-amount-btn"
                    :class="{ active: rechargeAmount && !quickAmounts.includes(Number(rechargeAmount)) }"
                    @click="focusCustomInput"
                  >
                    <input
                      v-model="rechargeAmount"
                      type="number"
                      placeholder="自定义"
                      class="custom-input"
                      @input="updatePaymentAmount"
                      @click.stop
                      @focus="selectCustomAmount"
                    >
                  </div>
                </div>

                <!-- 支付方式选择 -->
                <div class="payment-methods-section">
                  <div class="payment-label">支付方式</div>
                  <div class="payment-methods">
                    <div
                      v-for="method in paymentMethods"
                      :key="method.key"
                      class="payment-method"
                      :class="{ active: selectedPaymentMethod === method.key }"
                      @click="selectPaymentMethod(method.key)"
                    >
                      <img :src="method.icon" :alt="method.label" class="payment-icon">
                      <span class="payment-name">{{ method.label }}</span>
                      <div v-if="selectedPaymentMethod === method.key" class="payment-check">
                        ✓
                      </div>
                    </div>
                  </div>
                </div>

                <div class="recharge-actions">
                  <el-button type="primary" class="recharge-btn" @click="handleRecharge">
                    立即充值
                  </el-button>
                </div>
              </div>

              <!-- 支付区域 -->
              <div v-if="showPayment" class="payment-section">
                <div class="qr-code-container">
                  <div class="qr-code">
                    <!-- 根据选择的支付方式显示不同的二维码 -->
                    <div v-if="selectedPaymentMethod === 'wechat'" class="qr-placeholder wechat-qr">
                      <img :src="require('@/assets/image/my/wx.png')" alt="微信支付" class="qr-icon">
                      <div class="qr-text">微信支付二维码</div>
                    </div>
                    <div v-else-if="selectedPaymentMethod === 'alipay'" class="qr-placeholder alipay-qr">
                      <img :src="require('@/assets/image/my/zfb.png')" alt="支付宝" class="qr-icon">
                      <div class="qr-text">支付宝二维码</div>
                    </div>
                  </div>
                  <div class="payment-info">
                    <div class="amount-due">
                      应付金额: <span class="amount-text">¥{{ paymentAmount }}</span>
                    </div>
                    <div class="payment-method-info">
                      <img
                        class="payment-icon"
                        :src="selectedPaymentMethod === 'wechat' ? require('@/assets/image/my/wx.png') : require('@/assets/image/my/zfb.png')"
                        :alt="selectedPaymentMethod === 'wechat' ? '微信支付' : '支付宝'"
                      >
                      <span class="payment-text">
                        使用{{ selectedPaymentMethod === 'wechat' ? '微信' : '支付宝' }}扫码支付
                      </span>
                    </div>
                    <div class="payment-tips">
                      请使用{{ selectedPaymentMethod === 'wechat' ? '微信' : '支付宝' }}扫描上方二维码完成支付
                    </div>
                  </div>
                </div>
                <div class="agreement-text">
                  支付即视为您同意<a href="#" class="agreement-link">《智蜂智造付费协议》</a>
                </div>
                <div class="payment-actions">
                  <el-button @click="closePayment">取消支付</el-button>
                  <el-button type="primary" @click="confirmPayment">确认支付</el-button>
                </div>
              </div>
            </template>

          </div>

          <!-- 发票管理 -->
          <div v-else-if="activeMenu === '4'" class="content-section invoice-section">
            <!-- 标签页 -->
            <div class="invoice-tabs">
              <div
                class="tab-item"
                :class="{ active: invoiceActiveTab === 'canApply' }"
                @click="switchInvoiceTab('canApply')"
              >
                可申请
              </div>
              <div
                class="tab-item"
                :class="{ active: invoiceActiveTab === 'applied' }"
                @click="switchInvoiceTab('applied')"
              >
                已申请
              </div>
              <div
                class="tab-item"
                :class="{ active: invoiceActiveTab === 'template' }"
                @click="switchInvoiceTab('template')"
              >
                发票模板
              </div>
            </div>

            <!-- 可申请标签页 -->
            <div v-if="invoiceActiveTab === 'canApply'" class="tab-content">
              <div class="table-header">
                <div class="header-cell">
                  <el-checkbox
                    v-model="selectAllOrders"
                    :indeterminate="isIndeterminate"
                    class="select-all-checkbox"
                    @change="handleSelectAllOrders"
                  >
                    全选
                  </el-checkbox>
                </div>
                <div class="header-cell">订单名称</div>
                <div class="header-cell">实付款</div>
                <div class="header-cell">日期</div>
              </div>
              <div class="table-body">
                <div v-for="order in canApplyOrders" :key="order.id" class="table-row">
                  <div class="row-checkbox">
                    <el-checkbox
                      v-model="selectedOrders"
                      :label="order.id"
                      class="order-checkbox"
                    />
                  </div>
                  <div class="row-cell order-name">{{ order.name }}</div>
                  <div class="row-cell payment-amount">¥{{ order.amount }}</div>
                  <div class="row-cell order-date">{{ order.date }}</div>
                </div>
              </div>
              <div class="action-section">
                <el-button
                  type="primary"
                  class="create-invoice-btn"
                  :disabled="selectedOrders.length === 0"
                  @click="showTemplateDialog"
                >
                  立即开票
                </el-button>
              </div>

              <!-- 分页组件 -->
              <div v-if="canApplyOrders.length > 0" class="pagination-container">
                <el-pagination
                  background
                  :current-page="canApplyOrdersPagination.currentPage"
                  :page-size="canApplyOrdersPagination.pageSize"
                  :total="canApplyOrdersPagination.total"
                  layout="prev, pager, next"
                  @current-change="handleCanApplyOrdersPageChange"
                />
              </div>

              <!-- 空状态 -->
              <div v-if="canApplyOrders.length === 0" class="empty-state">
                <div class="empty-icon">📋</div>
                <div class="empty-text">暂无可申请发票的订单</div>
                <div class="empty-desc">购买案例后可申请发票</div>
              </div>
            </div>

            <!-- 已申请标签页 -->
            <div v-else-if="invoiceActiveTab === 'applied'" class="tab-content">
              <div class="applied-list">
                <div v-for="application in appliedList" :key="application.id" class="applied-item">
                  <div class="applied-info">
                    <div class="applied-header">
                      <div class="info-row">
                        <span class="info-label">申请时间：</span>
                        <span class="info-value">{{ application.applyTime }}</span>
                      </div>
                      <div class="applied-status">
                        <span class="status-text">已申请</span>
                      </div>
                    </div>
                    <div class="applied-details">
                      <div class="info-row applied-row-three">
                        <div class="info-group">
                          <span class="info-label">单位名称：</span>
                          <span class="info-value">{{ application.companyName }}</span>
                        </div>
                        <div class="info-group">
                          <span class="info-label">联系电话：</span>
                          <span class="info-value">{{ application.phone }}</span>
                        </div>
                        <div class="info-group">
                          <span class="info-label">地址：</span>
                          <span class="info-value">{{ application.address }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 分页组件 -->
              <div v-if="appliedList.length > 0" class="pagination-container">
                <el-pagination
                  background
                  :current-page="appliedListPagination.currentPage"
                  :page-size="appliedListPagination.pageSize"
                  :total="appliedListPagination.total"
                  layout="prev, pager, next"
                  @current-change="handleAppliedListPageChange"
                />
              </div>

              <!-- 空状态 -->
              <div v-if="appliedList.length === 0" class="empty-state">
                <div class="empty-icon">📋</div>
                <div class="empty-text">暂无已申请的发票</div>
                <div class="empty-desc">申请发票后在此查看状态</div>
              </div>
            </div>

            <!-- 发票模板标签页 -->
            <div v-else class="tab-content">
              <div class="template-header">
                <el-button type="primary" class="add-template-btn" @click="goToAddTemplate">
                  添加发票模板
                </el-button>
              </div>
              <div class="template-list">
                <div v-for="template in templateList" :key="template.id" class="template-item">
                  <div class="template-info">
                    <div class="info-row">
                      <span class="info-label">发票类型：</span>
                      <span class="info-value">{{ template.invoice_type_text }}</span>
                    </div>
                    <div class="info-row template-row-two" style="margin-bottom: 20px;">
                      <div class="info-group">
                        <span class="info-label">单位名称：</span>
                        <span class="info-value">{{ template.companyName }}</span>
                      </div>
                      <div class="info-group">
                        <span class="info-label">纳税人识别号：</span>
                        <span class="info-value">{{ template.taxNumber }}</span>
                      </div>
                    </div>
                    <div class="info-row template-row-three">
                      <div class="info-group">
                        <span class="info-label">开户行：</span>
                        <span class="info-value">{{ template.bankName }}</span>
                      </div>
                      <div class="info-group">
                        <span class="info-label">开户行账号：</span>
                        <span class="info-value">{{ template.bankAccount }}</span>
                      </div>
                      <div class="info-group">
                        <span class="info-label">地址：</span>
                        <span class="info-value">{{ template.address }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 空状态 -->
              <div v-if="templateList.length === 0" class="empty-state">
                <div class="empty-icon">📋</div>
                <div class="empty-text">暂无发票模板</div>
                <div class="empty-desc">点击上方按钮添加发票模板</div>
              </div>
            </div>
          </div>

          <!-- 开通会员 -->
          <div v-else-if="activeMenu === '5'" class="content-section membership-section">
            <!-- 已开通会员 - 显示会员信息 -->
            <div v-if="userInfo.is_member === 1" class="membership-info-section">
              <div class="membership-status-card">
                <div class="status-header">
                  <!-- <img class="vip-icon" :src="require('@/assets/image/vip1.png')" alt="VIP"> -->
                  <div class="status-title">
                    <h2>您已是会员</h2>
                    <p class="status-desc">享受会员专属权益</p>
                  </div>
                </div>
                <div class="membership-details">
                  <div class="detail-item">
                    <span class="detail-label">会员过期时间：</span>
                    <span class="detail-value">{{ userInfo.member_expire_time || '--' }}</span>
                  </div>
                  <div class="detail-item">
                    <span class="detail-label">会员过期日期：</span>
                    <span class="detail-value">{{ userInfo.member_expire_date || '--' }}</span>
                  </div>
                  <div class="detail-item highlight">
                    <span class="detail-label">剩余天数：</span>
                    <span class="detail-value">{{ userInfo.member_days_remaining || 0 }} 天</span>
                  </div>
                </div>
              </div>

              <!-- 会员权益 -->
              <div class="benefits-section">
                <div class="benefits-title">会员权益</div>
                <div class="benefits-list">
                  <div class="benefit-item">
                    <img class="benefit-icon" :src="require('@/assets/image/al/zjs.png')" alt="咨询图标">
                    <span class="benefit-text">开通年会员可以享受造价师咨询的9折优惠</span>
                  </div>
                  <div class="benefit-item">
                    <img class="benefit-icon" :src="require('@/assets/image/al/icon.png')" alt="案例图标">
                    <span class="benefit-text">开通年会员可以享受造收费案例的9折优惠</span>
                  </div>
                </div>
              </div>

              <!-- 续费按钮 -->
              <div class="renewal-section">
                <el-button
                  type="primary"
                  class="renewal-button"
                  :loading="membershipLoading"
                  @click="handleActivateMembership"
                >
                  续费会员
                </el-button>
              </div>
            </div>

            <!-- 未开通会员 - 显示开通界面 -->
            <div v-else class="membership-activate-section">
              <!-- 年卡价格 -->
              <div class="membership-card">
                <div class="card-title">年卡</div>
                <div class="price-info">
                  <span class="current-price">¥199</span>
                  <span class="original-price">¥299</span>
                </div>
              </div>

              <!-- 会员权益 -->
              <div class="benefits-section">
                <div class="benefits-title">会员权益</div>
                <div class="benefits-list">
                  <div class="benefit-item">
                    <img class="benefit-icon" :src="require('@/assets/image/al/zjs.png')" alt="咨询图标">
                    <span class="benefit-text">开通年会员可以享受造价师咨询的9折优惠</span>
                  </div>
                  <div class="benefit-item">
                    <img class="benefit-icon" :src="require('@/assets/image/al/icon.png')" alt="案例图标">
                    <span class="benefit-text">开通年会员可以享受造收费案例的9折优惠</span>
                  </div>
                </div>
              </div>

              <!-- 支付区域 -->
              <div class="payment-section">
                <div class="payment-label">支付方式</div>
                <div class="payment-methods">
                  <div
                    v-for="method in membershipPaymentMethods"
                    :key="method.key"
                    class="payment-method"
                    :class="{ active: selectedMembershipPaymentMethod === method.key }"
                    @click="selectedMembershipPaymentMethod = method.key"
                  >
                    <img v-if="method.icon" :src="method.icon" :alt="method.label" class="payment-icon">
                    <span v-else class="payment-icon yue-icon">余</span>
                    <span class="payment-name">{{ method.label }}</span>
                    <div v-if="selectedMembershipPaymentMethod === method.key" class="payment-check">✓</div>
                  </div>
                </div>
                <div class="qr-code-container">
                  <div class="qr-code">
                    <div v-if="selectedMembershipPaymentMethod === 'wechat'" class="qr-placeholder wechat-qr">
                      <img :src="require('@/assets/image/my/wx.png')" alt="微信支付" class="qr-icon">
                      <div class="qr-text">微信支付二维码</div>
                    </div>
                    <div v-else-if="selectedMembershipPaymentMethod === 'alipay'" class="qr-placeholder alipay-qr">
                      <img :src="require('@/assets/image/my/zfb.png')" alt="支付宝" class="qr-icon">
                      <div class="qr-text">支付宝二维码</div>
                    </div>
                    <div v-else class="qr-placeholder">
                      <div class="qr-text">余额支付无需扫码</div>
                    </div>
                  </div>
                  <div class="payment-info">
                    <div class="amount-due">
                      应付金额: <span class="amount-text">¥199</span>
                    </div>
                    <div class="payment-methods">
                      <img
                        v-if="selectedMembershipPaymentMethod !== 'yue'"
                        class="payment-icon"
                        :src="selectedMembershipPaymentMethod === 'wechat' ? require('@/assets/image/al/wx.png') : require('@/assets/image/al/zfb.png')"
                        :alt="selectedMembershipPaymentMethod === 'wechat' ? '微信' : '支付宝'"
                      >
                      <span class="payment-text">
                        {{
                          selectedMembershipPaymentMethod === 'yue'
                            ? '使用余额支付'
                            : `使用${selectedMembershipPaymentMethod === 'wechat' ? '微信' : '支付宝'}扫码支付`
                        }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="agreement-text">
                  支付即视为您同意<a href="#" class="agreement-link">《智蜂智造付费协议》</a>
                </div>
                <!-- 立即支付按钮 -->
                <div class="payment-button-container">
                  <el-button
                    type="primary"
                    class="pay-button"
                    :loading="membershipLoading"
                    @click="handleActivateMembership"
                  >
                    立即支付
                  </el-button>
                </div>
              </div>
            </div>
          </div>

          <!-- 供应商名片 -->
          <div v-else-if="activeMenu === '6'" class="content-section supplier-card-section">
            <!-- 公司图片 -->
            <!-- <div class="company-image-section">
              <div class="image-label">公司图片</div>
              <div class="image-upload">
                <div class="image-placeholder" @click="uploadCompanyImage">
                  <img v-if="!companyInfo.companyImage" :src="require('@/assets/image/up2.png')" alt="上传图片" class="placeholder-icon">
                  <div v-else class="image-preview">
                    <img :src="companyInfo.companyImage" alt="公司图片" class="preview-img">
                    <div class="image-overlay">
                      <div class="change-text">更换</div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

            <!-- 公司信息表单 -->
            <div class="company-form">
              <div class="form-group">
                <label class="form-label">公司名称</label>
                <el-input
                  v-model="companyInfo.companyName"
                  placeholder="请输入公司名称"
                  class="form-input"
                />
              </div>

              <div class="form-group">
                <label class="form-label">主营业务</label>
                <el-input
                  v-model="companyInfo.mainBusiness"
                  placeholder="请输入你的主营业务"
                  class="form-input"
                />
              </div>

              <div class="form-group">
                <label class="form-label">地区</label>
                <el-input
                  v-model="companyInfo.region"
                  placeholder="请输入地区"
                  class="form-input"
                />
              </div>

              <div class="form-group">
                <label class="form-label">手机号码</label>
                <el-input
                  v-model="companyInfo.phone"
                  placeholder="请输入手机号码"
                  class="form-input"
                />
              </div>

              <div class="form-group">
                <label class="form-label">其他联系方式</label>
                <el-input
                  v-model="companyInfo.otherContact"
                  placeholder="请输入你的其他联系方式"
                  class="form-input"
                />
              </div>

              <div class="form-actions">
                <el-button type="primary" class="save-btn" @click="saveCompanyInfo">
                  保存
                </el-button>
              </div>
            </div>
          </div>

          <!-- 我的关注 -->
          <div v-else-if="activeMenu === '7'" class="content-section my-follows-section">

            <div class="follows-grid">
              <div
                v-for="item in followsList"
                :key="item.id"
                class="follow-card"
              >
                <div class="card-image">
                  <img :src="item.image" :alt="item.title" class="project-image">
                </div>
                <div class="card-content">
                  <div class="card-title">{{ item.title }}</div>
                  <div class="card-desc">{{ item.description }}</div>
                </div>
              </div>
            </div>

            <!-- 分页组件 -->
            <div v-if="followsList.length > 0" class="pagination-container">
              <el-pagination
                background
                :current-page="followsPagination.currentPage"
                :page-size="followsPagination.pageSize"
                :total="followsPagination.total"
                layout="prev, pager, next"
                @current-change="handleFollowsPageChange"
              />
            </div>

            <!-- 空状态 -->
            <div v-if="followsList.length === 0" class="empty-state">
              <div class="empty-icon">📋</div>
              <div class="empty-text">暂无关注的项目</div>
              <div class="empty-desc">去发现更多精彩项目吧</div>
            </div>
          </div>

          <!-- 我的收藏 -->
          <div v-else-if="activeMenu === '8'" class="content-section my-follows-section">
            <!-- Tab 切换 -->
            <div class="collection-tabs">
              <div
                v-for="tab in collectionTabs"
                :key="tab.value"
                class="collection-tab-item"
                :class="{ active: activeCollectionTab === tab.value }"
                @click="switchCollectionTab(tab.value)"
              >
                {{ tab.label }}
              </div>
            </div>

            <!-- 案例列表 -->
            <div v-if="activeCollectionTab === 'case'">
              <div class="follows-grid">
                <div
                  v-for="item in collectionsList"
                  :key="item.id"
                  class="follow-card"
                >
                  <div class="card-image">
                    <img :src="item.image" :alt="item.title" class="project-image">
                  </div>
                  <div class="card-content">
                    <div class="card-title">{{ item.title }}</div>
                    <div class="card-desc">{{ item.description }}</div>
                  </div>
                </div>
              </div>

              <!-- 分页组件 -->
              <div v-if="collectionsList.length > 0" class="pagination-container">
                <el-pagination
                  background
                  :current-page="collectionsPagination.currentPage"
                  :page-size="collectionsPagination.pageSize"
                  :total="collectionsPagination.total"
                  layout="prev, pager, next"
                  @current-change="handleCollectionsPageChange"
                />
              </div>

              <!-- 空状态 -->
              <div v-if="collectionsList.length === 0" class="empty-state">
                <div class="empty-icon">📋</div>
                <div class="empty-text">暂无收藏的项目</div>
                <div class="empty-desc">去发现更多精彩项目吧</div>
              </div>
            </div>

            <!-- 问答列表 -->
            <div v-else-if="activeCollectionTab === 'qa'">
              <div v-if="qaCollectionsList.length > 0" class="qa-collections-list">
                <div
                  v-for="item in qaCollectionsList"
                  :key="item.id"
                  class="qa-card"
                  @click="openQADetail(item)"
                >
                  <div class="qa-card-header" style="margin-bottom: 10px;">
                    <img v-if="item.avatar" class="avatar" :src="item.avatar" alt="头像">
                    <div class="qa-head">
                      <div class="qa-row">
                        <span v-if="item.name" class="name" :title="item.name">{{ item.name }}</span>
                        <span class="status" :class="{ unsolved: item.type === 1, solved: item.type === 2 }">
                          {{ item.type === 1 ? '未解决' : '已解决' }}
                        </span>
                        <span class="category">{{ item.category || '工业建筑' }}</span>
                      </div>
                    </div>
                    <div class="qa-card-right">回答人数：{{ item.answerCount }}</div>
                  </div>
                  <div v-if="item.title" class="qa-title">{{ item.title }}</div>
                  <div v-if="item.content" class="qa-content">{{ item.content }}</div>
                  <div v-if="item.image" class="qa-card-image">
                    <img :src="item.image" alt="封面">
                  </div>
                  <div class="qa-card-footer">
                    <span class="bounty">悬赏金额：¥ {{ item.bounty }}</span>
                    <div class="right-actions">
                      <span class="cancel-collect-btn" @click.stop="handleCancelCollect(item)">
                        <img class="cancel-collect-icon" :src="require('@/assets/image/scy.png')" alt="取消收藏">
                        取消收藏
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="empty-state">
                <div class="empty-icon">📝</div>
                <div class="empty-text">暂无收藏的问答</div>
                <div class="empty-desc">去发现更多精彩问答吧</div>
              </div>

              <!-- 分页组件 -->
              <div v-if="qaCollectionsList.length > 0" class="pagination-container">
                <el-pagination
                  background
                  :current-page="qaCollectionsPagination.currentPage"
                  :page-size="qaCollectionsPagination.pageSize"
                  :total="qaCollectionsPagination.total"
                  layout="prev, pager, next"
                  @current-change="handleQACollectionsPageChange"
                />
              </div>
            </div>
          </div>

          <!-- 问题反馈 -->
          <div v-else-if="activeMenu === '9'" class="content-section feedback-section">
            <!-- 问题分类 -->
            <div class="feedback-categories">
              <div class="category-label">问题分类</div>
              <div class="category-buttons">
                <div
                  v-for="category in feedbackCategories"
                  :key="category.id"
                  class="category-btn"
                  :class="{ active: selectedCategory === category.id }"
                  @click="selectCategory(category.id)"
                >
                  {{ category.name }}
                </div>
              </div>
            </div>

            <!-- 备注输入 -->
            <div class="feedback-notes">
              <div class="notes-label">备注</div>
              <el-input
                v-model="feedbackData.notes"
                type="textarea"
                :rows="6"
                placeholder="详细描述有助于您的问题快速解决~"
                class="notes-textarea"
                maxlength="500"
                show-word-limit
              />
            </div>

            <!-- 上传问题图片 -->
            <div class="feedback-upload">
              <div class="upload-label">上传问题图片</div>
              <div class="upload-area">
                <div class="upload-placeholder" @click="uploadFeedbackImage">
                  <img v-if="!feedbackData.image" :src="require('@/assets/image/up2.png')" alt="上传图片" class="upload-icon">
                  <div v-else class="image-preview">
                    <img :src="feedbackData.image" alt="问题图片" class="preview-img">
                    <div class="image-overlay">
                      <div class="change-text">更换</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 提交按钮 -->
            <div class="feedback-actions">
              <el-button
                type="primary"
                class="submit-btn"
                :disabled="!selectedCategory || !feedbackData.notes.trim()"
                @click="submitFeedback"
              >
                提交
              </el-button>
            </div>
          </div>

          <!-- 咨询 -->
          <div v-else-if="activeMenu === '12'" class="content-section consulting-clients-section" style="max-width: 100%;">
            <div class="consulting-container">
              <div class="consulting-wrapper">
                <!-- 左侧留言列表 -->
                <div class="message-list-panel">
                  <div class="panel-header">
                    <h3>咨询</h3>
                  </div>
                  <div class="message-list">
                    <div
                      v-for="item in messageList"
                      :key="item.contact_id"
                      class="message-item"
                      :class="{ active: selectedUserId === item.contact_id }"
                      @click="selectUser(item)"
                    >
                      <div class="avatar-container">
                        <img :src="getImageUrl(item.avatar)" :alt="item.nickname" class="user-avatar">
                      </div>
                      <div class="message-content">
                        <div class="user-info" style="padding: 0;">
                          <div
                            class="nickname"
                            :title="getMessageListDisplayName(item)"
                          >
                            {{ item.nickname }}<template v-if="hasMessageRemark(item)">（{{ item.remark }}）</template>
                          </div>
                          <span class="message-time">{{ item.time_text }}</span>
                        </div>
                        <div class="message-row">
                          <div class="latest-message">{{ item.latest_message }}</div>
                          <div v-if="item.has_unread" class="unread-badge">
                            {{ item.unread_count }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 右侧对话详情 -->
                <div class="conversation-panel">
                  <div v-if="selectedUser" class="conversation-header">
                    <div class="user-info">
                      <img :src="getImageUrl(selectedUser.avatar)" class="user-avatar">
                      <div
                        class="nickname"
                        :title="getMessageListDisplayName(selectedUser)"
                      >
                        {{ selectedUser.nickname }}<template v-if="hasMessageRemark(selectedUser)">（{{ selectedUser.remark }}）</template>
                      </div>
                    </div>
                    <div v-if="Number(userInfo.group_id) === 2" class="header-actions">
                      <el-button size="small" @click="openRemarkEdit">修改备注</el-button>
                      <el-button type="primary" size="small" @click="showChargeReplyModal">
                        收费回复
                      </el-button>
                    </div>
                  </div>

                  <div ref="conversationContent" class="conversation-content">
                    <!-- 加载更多提示 -->
                    <div v-if="consultingLoading && consultingPagination.page > 1" class="loading-more">
                      <i class="el-icon-loading" />
                      <span>加载更多消息...</span>
                    </div>

                    <div v-if="messages.length === 0 && !consultingLoading" class="empty-message">
                      <p>暂无对话记录</p>
                    </div>
                    <div v-else class="messages-container">
                      <div v-if="consultingPagination.hasMore" class="load-more-tip" @click="loadMoreMessages">
                        <span v-if="consultingLoading && consultingPagination.page > 1">加载中...</span>
                        <span v-else>点击查看更多</span>
                      </div>
                      <div
                        v-for="message in messages"
                        :key="message.id"
                        class="msg"
                        :class="message.sender_type === 2 ? 'left' : 'right'"
                      >
                        <img
                          :src="message.sender_info && message.sender_info.avatar ? getImageUrl(message.sender_info.avatar) : (message.sender_type === 1 ? require('@/assets/image/2.jpg') : require('@/assets/image/1.jpg'))"
                          class="avatar"
                          :alt="message.sender_info ? message.sender_info.nickname : ''"
                        >
                        <div class="bubble" :class="message.sender_type === 1 ? 'primary' : ''">
                          <!-- 多行消息内容 -->
                          <template v-for="(line, index) in parseMessage(message.message)">
                            <!-- 图片消息 -->
                            <div v-if="isImageMessage(line)" :key="`image-${index}`" class="message-image">
                              <img
                                :src="getMessageImageUrl(line)"
                                alt="图片"
                                class="message-img"
                                @click="previewImage(getMessageImageUrl(line))"
                              >
                            </div>
                            <!-- 文件消息 -->
                            <div v-else-if="isFileMessage(line)" :key="`file-${index}`" class="message-file">
                              <div class="file-info">
                                <img src="@/assets/image/al/file.png" alt="文件" class="file-icon">
                                <span class="file-name">{{ getFileName(line) }}</span>
                              </div>
                              <a
                                :href="getFileUrl(line)"
                                target="_blank"
                                class="file-link"
                                @click.stop
                              >
                                下载文件
                              </a>
                            </div>
                            <!-- 普通文本消息 -->
                            <div v-else-if="line.trim()" :key="`text-${index}`" class="message-text">
                              {{ line }}
                            </div>
                          </template>
                          <!-- <div v-if="message.is_paid === 1" class="charge-info">
                            <div class="charge-text">针对此问题需要收取<span class="amount">{{ message.amount }}</span>元的费用才能解答。</div>
                            <div class="charge-btn">立即解答</div>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="message-input">
                    <div class="consulting-upload-buttons">
                      <input
                        ref="consultingImageInput"
                        type="file"
                        accept="image/*"
                        style="display: none"
                        @change="handleConsultingImageUpload"
                      >
                      <input
                        ref="consultingFileInput"
                        type="file"
                        style="display: none"
                        @change="handleConsultingFileUpload"
                      >
                      <img
                        class="consulting-upload-icon"
                        src="@/assets/image/al/img.png"
                        alt="上传图片"
                        @click="triggerConsultingImageUpload"
                      >
                      <img
                        class="consulting-upload-icon"
                        src="@/assets/image/al/file.png"
                        alt="上传文件"
                        @click="triggerConsultingFileUpload"
                      >
                    </div>
                    <div class="input-area">
                      <el-input
                        v-model="inputMessage"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入文字~"
                        resize="none"
                        @keyup.enter.ctrl="sendMessage"
                      />
                      <el-button type="primary" :disabled="!inputMessage.trim()" @click="sendMessage">
                        发送
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 申诉 -->
          <div v-else-if="activeMenu === '13'" class="content-section engineer-appeal-section">
            <!-- 申诉表单 -->
            <div class="appeal-form">
              <div class="form-title">发布问题</div>
              <!-- 问题内容输入 -->
              <div class="form-group">
                <el-input
                  v-model="appealData.content"
                  type="textarea"
                  :rows="6"
                  placeholder="请输入您要申诉的问题"
                  class="appeal-textarea"
                  maxlength="200"
                  show-word-limit
                />
              </div>

              <!-- 上传图片 -->
              <div class="form-group">
                <div class="upload-label">上传图片</div>
                <div class="upload-area">
                  <div class="upload-placeholder" @click="uploadAppealImage">
                    <img v-if="!appealData.image" :src="require('@/assets/image/up2.png')" alt="上传图片" class="upload-icon">
                    <div v-else class="image-preview">
                      <img :src="appealData.image" alt="申诉图片" class="preview-img">
                      <div class="image-overlay">
                        <div class="change-text">更换</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 提交按钮 -->
              <div class="form-actions">
                <el-button
                  type="primary"
                  class="submit-btn"
                  :disabled="!appealData.content.trim()"
                  @click="submitAppeal"
                >
                  立即提交
                </el-button>
              </div>
            </div>
          </div>

          <!-- 造价师信息 -->
          <div v-else-if="activeMenu === '14'" class="content-section engineer-info-section">
            <!-- 造价师信息表单 -->
            <div class="engineer-info-form">
              <div class="form-title">造价师信息</div>

              <!-- 基本信息展示 -->
              <div class="engineer-basic-info">
                <div class="info-item">
                  <span class="info-label">姓名：</span>
                  <span class="info-value">{{ engineerInfo.name || '未设置' }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">认证状态：</span>
                  <span class="info-value">{{ engineerInfo.certification_text || '未认证' }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">企业认证：</span>
                  <span class="info-value">{{ engineerInfo.enterprise_text || '未认证' }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">在线状态：</span>
                  <span class="info-value">{{ engineerInfo.online_text || '离线' }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">评分：</span>
                  <span class="info-value">{{ engineerInfo.rating_text || '0分' }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">咨询次数：</span>
                  <span class="info-value">{{ engineerInfo.consultation_count || 0 }}次</span>
                </div>
                <div class="info-item">
                  <span class="info-label">从业时间：</span>
                  <span class="info-value">{{ engineerInfo.work_start_time_text || '未设置' }}</span>
                </div>
              </div>

              <!-- 个人形象照 -->
              <div class="form-group">
                <label class="form-label">个人形象照</label>
                <div class="engineer-avatar-editor">
                  <img class="engineer-avatar-preview" :src="engineerInfo.avatar ? getImageUrl(engineerInfo.avatar) : require('@/assets/image/logo.png')" alt="个人形象照">
                  <div class="engineer-avatar-actions">
                    <el-button type="primary" plain size="small" @click="uploadEngineerAvatar">
                      更换形象照
                    </el-button>
                    <div class="avatar-tip">建议尺寸：600 × 800 像素（与造价师服务列表展示比例一致）</div>
                  </div>
                </div>
              </div>

              <!-- 个人简介 -->
              <!-- <div class="form-group">
                <label class="form-label">个人简介</label>
                <el-input
                  v-model="engineerInfo.introduction"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入个人简介"
                  class="engineer-textarea"
                  maxlength="500"
                  show-word-limit
                />
              </div> -->

              <!-- 专业领域 -->
              <div class="form-group">
                <label class="form-label">专业领域</label>
                <el-input
                  v-model="engineerInfo.specialty"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入您对自己的专业领域描述"
                  class="engineer-textarea"
                  maxlength="200"
                  show-word-limit
                />
              </div>

              <!-- 个人描述 -->
              <div class="form-group">
                <label class="form-label">个人描述</label>
                <el-input
                  v-model="engineerInfo.miaoshu"
                  type="textarea"
                  :rows="4"
                  placeholder="请输入您对自己的个人描述"
                  class="engineer-textarea"
                  maxlength="500"
                  show-word-limit
                />
              </div>

              <!-- 所在地区 -->
              <div class="form-group">
                <label class="form-label">所在地区</label>
                <el-input
                  v-model="engineerInfo.region"
                  placeholder="请输入所在地区，如：河南郑州"
                  class="engineer-input"
                  maxlength="50"
                />
              </div>

              <!-- 职称 -->
              <div class="form-group">
                <label class="form-label">职称</label>
                <el-select
                  v-model="engineerInfo.title"
                  placeholder="请选择职称"
                  class="engineer-select"
                >
                  <el-option label="高级工程师" value="高级工程师" />
                  <el-option label="工程师" value="工程师" />
                  <el-option label="助理工程师" value="助理工程师" />
                </el-select>
              </div>

              <!-- 造价师级别 -->
              <div class="form-group">
                <label class="form-label">造价师级别</label>
                <el-select
                  v-model="engineerInfo.engineer_level"
                  placeholder="请选择造价师级别"
                  class="engineer-select"
                >
                  <el-option label="一级" :value="1" />
                  <el-option label="二级" :value="2" />
                </el-select>
              </div>

              <!-- 荣誉墙 -->
              <div class="form-group">
                <label class="form-label">荣誉墙</label>
                <div class="honor-wall-section">
                  <div class="upload-area">
                    <div
                      v-for="(image, index) in engineerInfo.honorImages"
                      :key="index"
                      class="honor-image-item"
                    >
                      <img :src="image" alt="荣誉证书" class="honor-image">
                      <div class="image-overlay">
                        <div class="remove-btn" @click="removeHonorImage(index)">删除</div>
                      </div>
                    </div>
                    <div
                      v-if="engineerInfo.honorImages.length < 6"
                      class="upload-placeholder"
                      @click="uploadHonorImage"
                    >
                      <img :src="require('@/assets/image/up2.png')" alt="上传图片" class="upload-icon">
                      <div class="upload-text">上传荣誉证书</div>
                    </div>
                  </div>
                  <div class="upload-tip">最多可上传6张荣誉证书</div>
                </div>
              </div>

              <!-- 提交按钮 -->
              <div class="form-actions">
                <el-button
                  type="primary"
                  class="submit-btn"
                  :loading="engineerInfoSubmitting"
                  @click="submitEngineerInfo"
                >
                  {{ engineerInfoSubmitting ? '保存中...' : '保存信息' }}
                </el-button>
              </div>
            </div>
          </div>

          <!-- 案例管理 -->
          <div v-else-if="activeMenu === '15'" class="content-section case-management-section">
            <!-- 案例管理头部 -->
            <div class="case-management-header">
              <div class="case-categories">
                <div class="category-item active">全部</div>
              </div>
              <div class="case-actions">
                <el-button type="primary" class="upload-case-btn" @click="goToUploadCase">上传案例</el-button>
                <el-button type="danger" class="delete-case-btn" :disabled="selectedCases.length === 0" @click="deleteSelectedCases">删除案例</el-button>
              </div>
            </div>

            <!-- 案例网格 -->
            <div class="case-grid">
              <div
                v-for="caseItem in costCases"
                :key="caseItem.id"
                class="case-item"
                @click="viewCaseDetail(caseItem)"
              >
                <div class="case-image">
                  <img :src="getCaseImage(caseItem)" :alt="caseItem.title">
                  <div class="case-checkbox" :class="{ selected: selectedCases.includes(caseItem.id) }" @click.stop="toggleCaseSelection(caseItem.id)">
                    <i v-if="selectedCases.includes(caseItem.id)" class="el-icon-check" />
                  </div>
                </div>
                <div class="case-title">{{ caseItem.title || '时代广场-中心花园项目改造......' }}</div>
              </div>
            </div>

            <!-- 分页 -->
            <div class="case-pagination">
              <el-pagination
                :current-page="casePagination.currentPage"
                :page-size="casePagination.pageSize"
                :total="casePagination.total"
                layout="prev, pager, next"
                background
                @current-change="handleCasePageChange"
              />
            </div>

            <!-- 删除按钮 -->
            <div v-if="selectedCases.length > 0" class="case-delete-action">
              <el-button
                type="primary"
                class="delete-immediately-btn"
                @click="deleteSelectedCases"
              >
                立即删除
              </el-button>
            </div>
          </div>

          <!-- 我的下载 -->
          <div v-else-if="activeMenu === '10'" class="content-section my-downloads-section">
            <!-- 下载列表 -->
            <div class="downloads-list">
              <div
                v-for="item in downloadsList"
                :key="item.id"
                class="download-item"
              >
                <div class="file-info">
                  <div class="file-icon">
                    <img :src="require('@/assets/image/al/bg.png')" :alt="item.type" class="type-icon">
                  </div>
                  <div class="file-details">
                    <div class="file-name">{{ item.name }}</div>
                    <div class="file-meta">
                      <span class="file-size">{{ item.size }}</span>
                      <span class="file-date">{{ item.downloadDate }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 空状态 -->
            <div v-if="downloadsList.length === 0" class="empty-state">
              <div class="empty-icon">📁</div>
              <div class="empty-text">暂无下载文件</div>
              <div class="empty-desc">去发现更多精彩内容吧</div>
            </div>
          </div>

          <!-- 更换手机号 -->
          <div v-else-if="activeMenu === '16'" class="content-section change-phone-section">
            <div class="form-container">
              <div class="form-title">更换手机号</div>

              <div class="form-content">
                <!-- 新手机号 -->
                <div class="form-group">
                  <label class="form-label">新手机号</label>
                  <el-input
                    v-model="phoneForm.newPhone"
                    type="tel"
                    placeholder="请输入你的新手机号"
                    class="form-input"
                    maxlength="11"
                    @input="validatePhone"
                  />
                  <div v-if="phoneError" class="error-message">
                    {{ phoneError }}
                  </div>
                </div>

                <!-- 验证码 -->
                <div class="form-group">
                  <label class="form-label">验证码</label>
                  <div class="verification-group">
                    <el-input
                      v-model="phoneForm.verificationCode"
                      type="text"
                      placeholder="请输入你的验证码"
                      class="verification-input"
                      maxlength="6"
                    />
                    <el-button
                      type="text"
                      class="get-code-btn"
                      :disabled="!canGetCode || countdown > 0"
                      @click="getVerificationCode"
                    >
                      {{ countdown > 0 ? `${countdown}s后重新获取` : '获取验证码' }}
                    </el-button>
                  </div>
                  <div v-if="codeError" class="error-message">
                    {{ codeError }}
                  </div>
                </div>

                <!-- 确定按钮 -->
                <div class="form-actions">
                  <el-button
                    type="primary"
                    class="confirm-btn"
                    :disabled="!canSubmitPhone"
                    @click="submitChangePhone"
                  >
                    确定
                  </el-button>
                </div>
              </div>
            </div>
          </div>

          <!-- 更换邮箱 -->
          <div v-else-if="activeMenu === '17'" class="content-section change-email-section">
            <div class="form-container">
              <div class="form-title">更换邮箱</div>

              <div class="form-content">
                <!-- 新邮箱地址 -->
                <div class="form-group">
                  <label class="form-label">新邮箱地址</label>
                  <el-input
                    v-model="emailForm.newEmail"
                    type="email"
                    placeholder="请输入你的新邮箱地址"
                    class="form-input"
                    @input="validateEmail"
                  />
                  <div v-if="emailError" class="error-message">
                    {{ emailError }}
                  </div>
                </div>

                <!-- 邮箱验证码 -->
                <div class="form-group">
                  <label class="form-label">邮箱验证码</label>
                  <div class="verification-group">
                    <el-input
                      v-model="emailForm.verificationCode"
                      type="text"
                      placeholder="请输入你的邮箱验证码"
                      class="verification-input"
                      maxlength="6"
                    />
                    <el-button
                      type="text"
                      class="get-code-btn"
                      :disabled="!canGetEmailCode || emailCountdown > 0"
                      @click="getEmailVerificationCode"
                    >
                      {{ emailCountdown > 0 ? `${emailCountdown}s后重新获取` : '获取验证码' }}
                    </el-button>
                  </div>
                  <div v-if="emailCodeError" class="error-message">
                    {{ emailCodeError }}
                  </div>
                </div>

                <!-- 新密码 -->
                <div class="form-group">
                  <label class="form-label">新密码</label>
                  <el-input
                    v-model="emailForm.newPassword"
                    type="password"
                    placeholder="请输入你的新密码"
                    class="form-input"
                    show-password
                    @input="validatePassword"
                  />
                  <div v-if="passwordError" class="error-message">
                    {{ passwordError }}
                  </div>
                </div>

                <!-- 确定按钮 -->
                <div class="form-actions">
                  <el-button
                    type="primary"
                    class="confirm-btn"
                    :disabled="!canSubmitEmail"
                    @click="submitChangeEmail"
                  >
                    确定
                  </el-button>
                </div>
              </div>
            </div>
          </div>

          <!-- 其他菜单内容占位 -->
          <div v-else class="content-placeholder">
            <div class="placeholder-text">{{ getCurrentMenuLabel() }}内容</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 注销账号弹窗 -->
    <div v-if="deregisterModalVisible" class="modal-overlay" @click="closeDeregisterModal">
      <div class="deregister-modal" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">注销账号</h3>
          <button class="close-btn" @click="closeDeregisterModal">×</button>
        </div>
        <div class="modal-content">
          <p class="modal-message">您确定要注销账号吗？</p>
        </div>
        <div class="modal-footer">
          <button class="cancel-btn" @click="closeDeregisterModal">取消</button>
          <button class="confirm-btn" @click="confirmDeregister">确定</button>
        </div>
      </div>
    </div>

    <!-- 退出登录弹窗 -->
    <div v-if="logoutModalVisible" class="modal-overlay" @click="closeLogoutModal">
      <div class="logout-modal" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">退出登录</h3>
          <button class="close-btn" @click="closeLogoutModal">×</button>
        </div>
        <div class="modal-content">
          <p class="modal-message">您确定要退出登录吗？</p>
        </div>
        <div class="modal-footer">
          <button class="cancel-btn" @click="closeLogoutModal">取消</button>
          <button class="confirm-btn" @click="confirmLogout">确定</button>
        </div>
      </div>
    </div>

    <!-- 发票模板选择弹窗 -->
    <div v-if="showTemplateSelectDialog" class="template-dialog-overlay" @click="cancelApplyInvoice">
      <div class="template-dialog" @click.stop>
        <div class="dialog-header">
          <h3 class="dialog-title">选择发票模板</h3>
          <button class="close-btn" @click="cancelApplyInvoice">×</button>
        </div>
        <div class="dialog-content">
          <div v-if="templateList.length === 0" class="empty-templates">
            <div class="empty-icon">📄</div>
            <div class="empty-text">暂无发票模板</div>
            <div class="empty-desc">请先创建发票模板</div>
          </div>
          <div v-else class="template-list">
            <div
              v-for="template in templateList"
              :key="template.id"
              class="template-item"
              :class="{ active: selectedTemplateId === template.id }"
              @click="selectedTemplateId = template.id"
            >
              <div class="template-radio">
                <el-radio
                  v-model="selectedTemplateId"
                  :label="template.id"
                  class="template-radio-input"
                />
              </div>
              <div class="template-info">
                <div class="template-name">{{ template.templateName }}</div>
                <div class="template-company">{{ template.companyName }}</div>
                <div class="template-details">
                  <span class="template-type">{{ template.invoice_type_text }}</span>
                  <span v-if="template.taxNumber" class="template-tax">税号：{{ template.taxNumber }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-footer">
          <el-button @click="cancelApplyInvoice">取消</el-button>
          <el-button
            type="primary"
            :disabled="!selectedTemplateId"
            @click="applyInvoice"
          >
            确定申请
          </el-button>
        </div>
      </div>
    </div>

    <!-- 收费回复弹窗 -->
    <el-dialog
      title="发起收费"
      :visible.sync="chargeReplyVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="charge-reply-form">
        <!-- 回复内容 -->
        <div class="form-group">
          <label class="form-label">回复内容</label>
          <el-input
            v-model="chargeReplyForm.message"
            type="textarea"
            :rows="6"
            placeholder="请输入您的回答内容"
            maxlength="1000"
            show-word-limit
          />
        </div>

        <!-- 收费金额 -->
        <div class="form-group">
          <label class="form-label">收费金额</label>
          <el-input
            v-model="chargeReplyForm.amount"
            type="number"
            placeholder="请输入收费金额"
            prefix="¥"
          />
        </div>

        <!-- 图片上传 -->
        <div class="form-group">
          <label class="form-label">图片附件</label>
          <div class="image-upload-section">
            <div class="upload-tip">最多可上传9张图片，支持jpg、png格式</div>
            <div class="image-list">
              <div
                v-for="(image, index) in chargeReplyForm.images"
                :key="index"
                class="image-item"
              >
                <img :src="getImageUrl(image)" :alt="`图片${index + 1}`" class="uploaded-image">
                <div class="image-overlay">
                  <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    circle
                    @click="removeChargeImage(index)"
                  />
                </div>
              </div>
              <div
                v-if="chargeReplyForm.images.length < 9"
                class="upload-placeholder"
                @click="uploadChargeImage"
              >
                <i class="el-icon-plus upload-icon" />
                <div class="upload-text">上传图片</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 文件上传 -->
        <div class="form-group">
          <label class="form-label">文件附件</label>
          <div class="file-upload-section">
            <div v-if="chargeReplyForm.files.length > 0" class="file-list">
              <div
                v-for="(file, index) in chargeReplyForm.files"
                :key="index"
                class="file-info"
              >
                <i class="el-icon-document file-icon" />
                <span class="file-name">{{ getFileName(file) }}</span>
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  @click="removeChargeFile(index)"
                >
                  删除
                </el-button>
              </div>
            </div>
            <div v-if="chargeReplyForm.files.length === 0" class="file-upload-area" @click="uploadChargeFile">
              <i class="el-icon-upload file-upload-icon" />
              <div class="file-upload-text">点击上传文件</div>
              <div class="file-upload-tip">支持.zip、.rar格式</div>
            </div>
            <div v-if="chargeReplyForm.files.length > 0" class="file-upload-area" @click="uploadChargeFile">
              <i class="el-icon-plus file-upload-icon" />
              <div class="file-upload-text">继续添加文件</div>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="chargeReplyVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="chargeReplySubmitting"
          :disabled="!chargeReplyForm.message.trim() || !chargeReplyForm.amount"
          @click="submitChargeReply"
        >
          确定
        </el-button>
      </div>
    </el-dialog>

    <!-- 问答详情弹窗 -->
    <el-dialog :visible.sync="qaDetailVisible" custom-class="responsive-dialog-wide" width="780px" top="5vh" :close-on-click-modal="false">
      <div v-if="currentQADetail" class="detail-body">
        <div class="detail-title">{{ currentQADetail.title }}</div>
        <div class="detail-section">
          <div class="section-title">问题描述</div>
          <div style="font-size: 16px;color: #333;margin-bottom: 10px;">{{ currentQADetail.content }}</div>
          <div v-if="currentQADetail.image" class="qa-card-image">
            <img :src="currentQADetail.image" alt="图片">
          </div>
          <div class="section-title" style="margin-top: 14px;">问题回答</div>
          <div v-if="currentQADetail.answers && currentQADetail.answers.length">
            <div v-for="a in currentQADetail.answers" :key="a.id" class="answer-item">
              <div style="font-size: 16px;color: #333;margin-bottom: 10px;">{{ a.content }}</div>
              <div v-if="a.image" class="qa-card-image"><img :src="a.image" alt="回答图片"></div>
              <div style="display: flex; align-items: center; justify-content: space-between;">
                <div class="answer-user">
                  <img class="answer-avatar" :src="a.avatar" alt="头像">
                  <span class="answer-name">{{ a.name }}</span>
                </div>
                <div class="answer-actions">
                  <span class="adopt" :class="{ active: a.is_adopted }">
                    <img :src="a.is_adopted ? require('@/assets/image/al/zany2.png') : require('@/assets/image/al/zany1.png')" class="action-icon">
                    采纳
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="loading-text">暂无回答</div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { rechargeBalance, getProfile, updateProfile, uploadImage, getRealNameStatus, getMyFollows, getSupplierInfo, updateSupplierInfo, getMyCollections, getInvoiceTemplates, getInvoiceableOrders, getAppliedInvoiceOrders, getEngineerDetail, updateCostEngineerInfo, getMessageBoardList, getConversationDetail, createConversation, updateMessageBoardRemark, activateMembership, getFavoriteList, getQuestionDetail, cancelFavorite, getMyQuestions, getMyAnswers, getQAIncome, getHistory } from '@/api/user'
import PresenceSelector from '@/components/PresenceSelector.vue'

export default {
  name: 'Profile',
  components: { PresenceSelector },
  data() {
    return {
      activeMenu: '1',
      userInfo: {
        id: null,
        nickname: '',
        avatar: '',
        group_id: null,
        is_member: 0,
        member_expire_time: '',
        member_expire_date: '',
        member_days_remaining: 0,
        money: '0.00',
        real_name_status: '未实名',
        real_name_verified: false,
        phone: '',
        account_start_date: '',
        account_end_date: '',
        user_type: '游客',
        createtime: null,
        logintime: null,
        status: 'normal',
        presence_status: 'online',
        // 兼容旧字段
        name: '',
        idCard: '',
        accountTime: ''
      },
      // 头像上传相关
      avatarFile: null,
      avatarUploading: false,
      // 会员开通相关
      membershipLoading: false,
      // 实名认证状态
      realNameStatus: {
        status: '未提交',
        status_code: -1,
        message: '尚未提交实名认证申请'
      },
      menuItems: [
        { key: '1', label: '个人资料' },
        { key: '2', label: '造价问答中心' },
        { key: '3', label: '我的余额' },
        { key: '4', label: '发票管理' },
        { key: '5', label: '开通会员' },
        { key: '6', label: '供应商名片' },
        { key: '12', label: '咨询' },
        { key: '13', label: '申诉' },
        { key: '14', label: '造价师信息' },
        { key: '15', label: '案例管理' },
        { key: '7', label: '我的关注' },
        { key: '8', label: '我的收藏' },
        { key: '9', label: '问题反馈' },
        // { key: '10', label: '我的下载' },
        { key: '11', label: '设置' }
      ],
      // 菜单图标映射（解决打包后动态require路径问题）
      menuIcons: {
        '1': { active: require('@/assets/image/my/1y.png'), inactive: require('@/assets/image/my/1n.png') },
        '2': { active: require('@/assets/image/my/2y.png'), inactive: require('@/assets/image/my/2n.png') },
        '3': { active: require('@/assets/image/my/3y.png'), inactive: require('@/assets/image/my/3n.png') },
        '4': { active: require('@/assets/image/my/4y.png'), inactive: require('@/assets/image/my/4n.png') },
        '5': { active: require('@/assets/image/my/5y.png'), inactive: require('@/assets/image/my/5n.png') },
        '6': { active: require('@/assets/image/my/6y.png'), inactive: require('@/assets/image/my/6n.png') },
        '7': { active: require('@/assets/image/my/7y.png'), inactive: require('@/assets/image/my/7n.png') },
        '8': { active: require('@/assets/image/my/8y.png'), inactive: require('@/assets/image/my/8n.png') },
        '9': { active: require('@/assets/image/my/9y.png'), inactive: require('@/assets/image/my/9n.png') },
        '11': { active: require('@/assets/image/my/11y.png'), inactive: require('@/assets/image/my/11n.png') },
        '12': { active: require('@/assets/image/my/12y.png'), inactive: require('@/assets/image/my/12n.png') },
        '13': { active: require('@/assets/image/my/13y.png'), inactive: require('@/assets/image/my/13n.png') },
        '14': { active: require('@/assets/image/my/14y.png'), inactive: require('@/assets/image/my/14n.png') },
        '15': { active: require('@/assets/image/my/15y.png'), inactive: require('@/assets/image/my/15n.png') }
      },
      // 余额相关数据
      rechargeAmount: 200,
      withdrawPassword: '',
      paymentAmount: 200,
      showPayment: false,
      quickAmounts: [50, 100, 200, 500, 1000, 2000],
      // 支付方式相关
      selectedPaymentMethod: 'wechat',
      paymentMethods: [
        { key: 'wechat', label: '微信支付', icon: require('@/assets/image/my/wx.png') },
        { key: 'alipay', label: '支付宝', icon: require('@/assets/image/my/zfb.png') }
      ],
      selectedMembershipPaymentMethod: 'wechat',
      membershipPaymentMethods: [
        { key: 'wechat', label: '微信支付', icon: require('@/assets/image/my/wx.png') },
        { key: 'alipay', label: '支付宝支付', icon: require('@/assets/image/my/zfb.png') },
        { key: 'yue', label: '余额支付', icon: '' }
      ],
      // 公司信息数据
      companyInfo: {
        id: null,
        companyImage: '',
        companyName: '',
        mainBusiness: '',
        region: '',
        phone: '',
        otherContact: ''
      },
      // 我的关注数据
      followsList: [],
      followsPagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 我的收藏数据
      collectionsList: [],
      collectionsPagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 收藏 Tab 切换
      activeCollectionTab: 'case', // case: 案例, qa: 问答
      collectionTabs: [
        { label: '案例', value: 'case' },
        { label: '问答', value: 'qa' }
      ],
      // 问答收藏数据
      qaCollectionsList: [],
      qaCollectionsPagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      // 问答详情
      qaDetailVisible: false,
      currentQADetail: null,
      // 造价问答中心（我的发布/我的回答）
      qaRecordTab: 'mypost',
      qaMyPosts: [],
      qaMyPostsPage: 1,
      qaMyPostsLimit: 10,
      qaMyPostsTotal: 0,
      qaMyAnswerTabs: [
        { label: '已回答', value: 'answered' },
        { label: '问答收入', value: 'income' },
        { label: '历史记录', value: 'history' }
      ],
      qaMyAnswerSubTab: 'answered',
      qaMyAnswers: [],
      qaMyAnswersPage: 1,
      qaMyAnswersLimit: 10,
      qaMyAnswersTotal: 0,
      qaIncomeTotal: 0,
      qaIncomeRecords: [],
      qaIncomePage: 1,
      qaIncomeLimit: 10,
      qaIncomeTotalCount: 0,
      qaHistoryList: [],
      qaHistoryPage: 1,
      qaHistoryLimit: 10,
      qaHistoryTotal: 0,
      // 问题反馈数据
      selectedCategory: 'bug',
      feedbackData: {
        notes: '',
        image: '', // 用于回显的完整URL
        imageUrl: '' // 用于提交的相对路径
      },
      // 申诉数据
      appealData: {
        content: '',
        image: '', // 用于回显的完整URL
        imageUrl: '' // 用于提交的相对路径
      },
      // 造价师信息数据
      engineerInfo: {
        specialty: '',
        miaoshu: '',
        region: '',
        title: '',
        engineer_level: 1,
        honorImages: [], // 用于显示的图片URL数组
        honorWall: '', // 用于提交的图片路径字符串
        // 新增字段
        avatar: '',
        name: '',
        introduction: '',
        certification_status: 0,
        certification_text: '',
        enterprise_certification: 0,
        enterprise_text: '',
        online_status: 0,
        online_text: '',
        rating: '0',
        rating_text: '0分',
        consultation_count: 0,
        work_start_time: 0,
        work_start_time_text: '',
        cases: []
      },
      engineerInfoSubmitting: false,
      // 案例管理数据
      costCases: [],
      selectedCases: [],
      selectAllCases: false,
      isIndeterminateCases: false,
      casePagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      feedbackCategories: [
        { id: 'suggestion', name: '产品建议' },
        { id: 'bug', name: '功能BUG' },
        { id: 'content', name: '内容订正' },
        { id: 'other', name: '其他' }
      ],
      // 设置展开状态
      settingsExpanded: false,
      // 当前选中的设置选项
      activeSettingsOption: '',
      // 注销账号弹窗显示状态
      deregisterModalVisible: false,
      // 退出登录弹窗显示状态
      logoutModalVisible: false,
      // 更换手机号表单数据
      phoneForm: {
        newPhone: '',
        verificationCode: ''
      },
      phoneError: '',
      codeError: '',
      countdown: 0,
      phoneTimer: null,
      // 更换邮箱表单数据
      emailForm: {
        newEmail: '',
        verificationCode: '',
        newPassword: ''
      },
      emailError: '',
      emailCodeError: '',
      passwordError: '',
      emailCountdown: 0,
      emailTimer: null,
      // 我的下载数据
      downloadsList: [
        {
          id: 1,
          name: '工程造价案例分析报告.pdf',
          type: 'pdf',
          size: '2.5MB',
          downloadDate: '2024-03-20',
          icon: require('@/assets/image/1.jpg')
        },
        {
          id: 2,
          name: '建筑工程预算表.xlsx',
          type: 'xls',
          size: '1.8MB',
          downloadDate: '2024-03-19',
          icon: require('@/assets/image/2.jpg')
        },
        {
          id: 3,
          name: '施工图纸设计图.dwg',
          type: 'dwg',
          size: '5.2MB',
          downloadDate: '2024-03-18',
          icon: require('@/assets/image/1.jpg')
        },
        {
          id: 4,
          name: '项目合同模板.docx',
          type: 'doc',
          size: '0.8MB',
          downloadDate: '2024-03-17',
          icon: require('@/assets/image/2.jpg')
        },
        {
          id: 5,
          name: '施工现场照片.jpg',
          type: 'image',
          size: '3.1MB',
          downloadDate: '2024-03-16',
          icon: require('@/assets/image/1.jpg')
        },
        {
          id: 6,
          name: '材料清单.pdf',
          type: 'pdf',
          size: '1.2MB',
          downloadDate: '2024-03-15',
          icon: require('@/assets/image/2.jpg')
        }
      ],
      // 发票管理相关数据
      invoiceActiveTab: 'canApply',
      selectedOrders: [],
      selectAllOrders: false,
      isIndeterminate: false,
      canApplyOrders: [],
      // 模板选择弹窗
      showTemplateSelectDialog: false,
      selectedTemplateId: null,
      canApplyOrdersPagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      appliedList: [],
      appliedListPagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      templateList: [],
      // 咨询相关数据
      messageList: [],
      selectedUserId: null,
      selectedUser: null,
      messages: [],
      inputMessage: '',
      consultingLoading: false,
      consultingPagination: {
        page: 1,
        limit: 10,
        total: 0,
        hasMore: true
      },
      // 收费回复相关数据
      chargeReplyVisible: false,
      chargeReplyForm: {
        message: '',
        amount: '',
        images: [],
        files: []
      },
      chargeReplySubmitting: false
    }
  },
  computed: {
    // 根据用户 group_id 判断是否显示供应商名片菜单
    filteredMenuItems() {
      return this.menuItems.filter(item => {
        // 如果用户 group_id 不是 3，则隐藏供应商名片菜单
        if (item.key === '6' && this.userInfo.group_id !== 3) {
          return false
        }
        // 不是造价师, 隐藏申诉、造价师信息、案例管理
        if ((item.key === '13' || item.key === '14' || item.key === '15') && this.userInfo.group_id !== 2) {
          return false
        }
        // 只有会员（group_id === 1）才显示开通会员菜单
        if (item.key === '5' && this.userInfo.group_id !== 1) {
          return false
        }
        // 只有会员（group_id === 1）才显示发票管理
        if (item.key === '4' && Number(this.userInfo.group_id) !== 1) {
          return false
        }
        // 只有造价师（group_id === 2）才显示造价问答中心
        if (item.key === '2' && Number(this.userInfo.group_id) !== 2) {
          return false
        }
        // 会员（group_id === 1）隐藏咨询
        if (item.key === '12' && Number(this.userInfo.group_id) === 1) {
          return false
        }
        // 造价师（group_id === 2）隐藏我的关注
        if (item.key === '7' && Number(this.userInfo.group_id) === 2) {
          return false
        }
        return true
      })
    },
    // 会员：仅充值；造价师：仅提现
    showBalanceRecharge() {
      return Number(this.userInfo.group_id) === 1
    },
    showBalanceWithdraw() {
      return Number(this.userInfo.group_id) === 2
    },
    showBalancePolicyLink() {
      const gid = Number(this.userInfo.group_id)
      return gid === 1 || gid === 2
    },
    balancePolicyLabel() {
      const gid = Number(this.userInfo.group_id)
      if (gid === 2) return '提现说明'
      if (gid === 1) return '注册说明'
      return ''
    },
    balancePolicyType() {
      const gid = Number(this.userInfo.group_id)
      if (gid === 2) return 2
      if (gid === 1) return 1
      return 1
    },
    showProfileEngineerCert() {
      return Number(this.userInfo.group_id) === 2
    },
    showProfileSupplierCert() {
      return Number(this.userInfo.group_id) === 3
    },
    profileCenterTitle() {
      const gid = Number(
        this.userInfo.group_id != null
          ? this.userInfo.group_id
          : (this.$store.getters.userInfo && this.$store.getters.userInfo.group_id)
      )
      return gid === 2 ? '工作平台' : '个人中心'
    }
  },
  watch: {
    '$route'(to, from) {
      // 如果路由参数中有 activeMenu，则更新当前选中的菜单
      if (to.path === '/profile/index' && to.query.activeMenu) {
        const m = String(to.query.activeMenu)
        const gid = Number(this.userInfo.group_id)
        if (m === '4' && gid !== 1) {
          this.activeMenu = '1'
          this.$router.replace({ path: '/profile/index' })
        } else if (m === '2' && gid !== 2) {
          this.activeMenu = '1'
          this.$router.replace({ path: '/profile/index' })
        } else if (m === '12' && gid === 1) {
          this.activeMenu = '1'
          this.$router.replace({ path: '/profile/index' })
        } else if (m === '7' && gid === 2) {
          this.activeMenu = '1'
          this.$router.replace({ path: '/profile/index' })
        } else {
          this.activeMenu = m
        }
      }
      if (to.path === '/profile/index' && to.query.refreshCases) {
        // 清除查询参数
        this.$router.replace({ path: '/profile/index' })
        // 刷新案例列表
        if (this.activeMenu === '15') {
          this.fetchMyCostCases()
        }
      }
    },
    // 监听订单选择变化，更新全选状态
    selectedOrders(newVal) {
      const total = this.canApplyOrders.length
      const selected = newVal.length

      if (selected === 0) {
        this.selectAllOrders = false
        this.isIndeterminate = false
      } else if (selected === total) {
        this.selectAllOrders = true
        this.isIndeterminate = false
      } else {
        this.selectAllOrders = false
        this.isIndeterminate = true
      }
    },
    // 监听已申请订单选择变化，更新全选状态
    selectedAppliedOrders(newVal) {
      const total = this.appliedOrders.length
      const selected = newVal.length

      if (selected === 0) {
        this.selectAllAppliedOrders = false
        this.isIndeterminateApplied = false
      } else if (selected === total) {
        this.selectAllAppliedOrders = true
        this.isIndeterminateApplied = false
      } else {
        this.selectAllAppliedOrders = false
        this.isIndeterminateApplied = true
      }
    }
  },
  async created() {
    // 从路由参数中读取 activeMenu，如果存在则设置为对应的菜单
    if (this.$route.query.activeMenu) {
      this.activeMenu = this.$route.query.activeMenu
    }
    await this.fetchProfile()
    if (this.activeMenu === '4' && Number(this.userInfo.group_id) !== 1) {
      this.activeMenu = '1'
      if (this.$route.query.activeMenu === '4') {
        this.$router.replace({ path: '/profile/index' })
      }
    }
    if (this.activeMenu === '2' && Number(this.userInfo.group_id) !== 2) {
      this.activeMenu = '1'
      if (this.$route.query.activeMenu === '2') {
        this.$router.replace({ path: '/profile/index' })
      }
    }
    if (this.activeMenu === '12' && Number(this.userInfo.group_id) === 1) {
      this.activeMenu = '1'
      if (this.$route.query.activeMenu === '12') {
        this.$router.replace({ path: '/profile/index' })
      }
    }
    if (this.activeMenu === '7' && Number(this.userInfo.group_id) === 2) {
      this.activeMenu = '1'
      if (this.$route.query.activeMenu === '7') {
        this.$router.replace({ path: '/profile/index' })
      }
    }
    this.fetchRealNameStatus()
    if (this.activeMenu === '2' && Number(this.userInfo.group_id) === 2) this.loadQaRecords()
  },
  mounted() {
    // 监听实名认证成功事件
    this.$on('auth-success', this.handleAuthSuccess)

    // 添加滚动监听
    this.$nextTick(() => {
      const container = this.$refs.conversationContent
      if (container) {
        container.addEventListener('scroll', this.handleScroll)
      }
    })
  },
  beforeDestroy() {
    if (this.phoneTimer) {
      clearInterval(this.phoneTimer)
    }
    if (this.emailTimer) {
      clearInterval(this.emailTimer)
    }

    // 移除滚动监听
    const container = this.$refs.conversationContent
    if (container) {
      container.removeEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    goCostEngineerCertification() {
      this.$router.push({ path: '/profile/costEngineerCertification' })
    },
    goSupplierCertification() {
      this.$router.push({ path: '/profile/supplierCertification' })
    },
    // 获取个人资料
    async fetchProfile() {
      try {
        const response = await getProfile()
        console.log('fetchProfile响应:', response)
        if (response && response.code === 1 && response.data) {
          const data = response.data
          console.log('用户数据:', data)
          this.userInfo = {
            id: data.id,
            nickname: data.nickname,
            avatar: data.avatar || '',
            group_id: data.group_id,
            is_member: data.is_member || 0,
            member_expire_time: data.member_expire_time || '',
            member_expire_date: data.member_expire_date || '',
            member_days_remaining: data.member_days_remaining || 0,
            money: data.money,
            real_name_status: data.real_name_status,
            real_name_verified: data.real_name_verified,
            phone: data.phone,
            account_start_date: data.account_start_date,
            account_end_date: data.account_end_date,
            user_type: data.user_type,
            createtime: data.createtime,
            logintime: data.logintime,
            status: data.status,
            presence_status: data.presence_status || 'online',
            // 兼容旧字段
            name: data.nickname,
            idCard: '', // 接口中没有身份证信息
            accountTime: `${data.account_start_date} ~ ${data.account_end_date}`
          }
          console.log('设置后的userInfo:', this.userInfo)
          this.$store.commit('user/MERGE_USER_INFO', {
            presence_status: this.userInfo.presence_status
          })
        }
      } catch (error) {
        console.error('获取个人资料失败:', error)
        this.$message && this.$message.error('获取个人资料失败')
      }
    },
    // 获取实名认证状态
    async fetchRealNameStatus() {
      try {
        const response = await getRealNameStatus()
        if (response && response.code === 1 && response.data) {
          this.realNameStatus = response.data
        }
      } catch (error) {
        console.error('获取实名认证状态失败:', error)
      }
    },
    // 开通会员
    async handleActivateMembership() {
      this.membershipLoading = true
      try {
        const paytypeMap = {
          wechat: 1,
          alipay: 2,
          yue: 3
        }
        const paymentMethod = this.selectedMembershipPaymentMethod || 'wechat'
        const response = await activateMembership({
          payment_method: paymentMethod,
          paytype: paytypeMap[paymentMethod]
        })
        if (response && response.code === 1) {
          this.$message.success('会员开通成功')
          // 重新获取用户信息以更新会员状态
          await this.fetchProfile()
        } else {
          this.$message.error(response?.msg || '会员开通失败')
        }
      } catch (error) {
        console.error('开通会员失败:', error)
        this.$message.error('开通会员失败，请重试')
      } finally {
        this.membershipLoading = false
      }
    },
    // 获取案例图片
    getCaseImage(caseItem) {
      // 优先使用images数组的第一张图片
      if (caseItem.images && Array.isArray(caseItem.images) && caseItem.images.length > 0) {
        return this.getImageUrl(caseItem.images[0])
      }
      // 兼容旧的image字段
      if (caseItem.image) {
        return this.getImageUrl(caseItem.image)
      }
      // 默认图片
      return require('@/assets/image/bg1.png')
    },

    // 获取头像URL（使用全局的图片处理方法）
    getAvatarUrl(avatarPath) {
      if (!avatarPath) {
        // return require('@/assets/image/logo.png')
      }
      return this.$getImageUrl(avatarPath)
    },
    // 获取图片URL
    getImageUrl(imagePath) {
    //   if (!imagePath) return require('@/assets/image/logo.png')
      if (imagePath.startsWith('http')) return imagePath
      // 处理相对路径，添加 /uploads/ 前缀
      if (!imagePath.startsWith('/uploads/')) {
        return `${process.env.VUE_APP_BASE_API}/uploads/${imagePath}`
      }
      return `${process.env.VUE_APP_BASE_API}${imagePath}`
    },
    // 触发头像上传
    triggerAvatarUpload() {
      this.$refs.avatarInput.click()
    },
    // 处理头像文件选择
    async handleAvatarChange(event) {
      const target = event.target
      const file = target.files[0]
      if (!file) return

      // 检查文件类型
      if (!file.type.startsWith('image/')) {
        this.$message.error('请选择图片文件')
        target.value = ''
        return
      }

      // 检查文件大小 (5MB)
      if (file.size / 1024 / 1024 > 5) {
        this.$message.error('图片大小不能超过 5MB')
        target.value = ''
        return
      }

      this.avatarUploading = true
      try {
        const response = await uploadImage(file)
        if (response && response.code === 1) {
          // 上传成功，更新头像显示
          this.userInfo.avatar = response.data.fullurl
          this.$message.success('头像上传成功')
        } else {
          this.$message.error(response?.msg || '头像上传失败')
        }
      } catch (error) {
        console.error('头像上传失败:', error)
        this.$message.error('头像上传失败，请重试')
      } finally {
        this.avatarUploading = false
        // 清空input值，允许重复选择同一文件
        target.value = ''
      }
    },
    // 保存个人资料
    async saveProfile() {
      try {
        const data = {
          nickname: this.userInfo.nickname,
          avatar: this.getAvatarPath() // 获取半路径
        }

        const response = await updateProfile(data)
        if (response && response.code === 1) {
          this.$message.success('保存成功')
          // 保存成功后重新获取用户信息
          await this.fetchProfile()
        } else {
          this.$message.error(response?.msg || '保存失败')
        }
      } catch (error) {
        console.error('保存个人资料失败:', error)
        this.$message.error('保存失败，请重试')
      }
    },
    // 获取头像半路径
    getAvatarPath() {
      if (!this.userInfo.avatar) return ''
      if (this.userInfo.avatar.startsWith('http')) {
        // 如果是完整URL，提取半路径
        const url = new URL(this.userInfo.avatar)
        return url.pathname
      }
      return this.userInfo.avatar
    },
    // 获取实名认证状态文本
    getRealNameStatusText() {
      switch (this.realNameStatus.status_code) {
        case -1:
          return '未提交'
        case 0:
          return '审核中'
        case 1:
          return '已通过'
        case 2:
          return '已拒绝'
        default:
          return this.realNameStatus.status || '未知'
      }
    },
    // 获取菜单图标（解决打包后动态require路径问题）
    getMenuIcon(menuKey) {
      const iconMap = this.menuIcons[menuKey]
      if (!iconMap) {
        // 如果找不到图标映射，返回默认图标
        return require('@/assets/image/my/1n.png')
      }
      // 判断是否选中（排除16和17，因为它们是设置下的子菜单）
      const isActive = this.activeMenu === menuKey && this.activeMenu !== '16' && this.activeMenu !== '17'
      return isActive ? iconMap.active : iconMap.inactive
    },
    // 获取实名认证状态样式类
    getRealNameStatusClass() {
      switch (this.realNameStatus.status_code) {
        case -1:
          return 'status-pending'
        case 0:
          return 'status-reviewing'
        case 1:
          return 'status-approved'
        case 2:
          return 'status-rejected'
        default:
          return 'status-unknown'
      }
    },
    getCurrentMenuLabel() {
      const currentItem = this.filteredMenuItems.find(item => item.key === this.activeMenu)
      return currentItem ? currentItem.label : ''
    },
    canGetCode() {
      return this.phoneForm.newPhone && this.phoneForm.newPhone.length === 11 && !this.phoneError
    },
    canSubmitPhone() {
      return this.phoneForm.newPhone &&
             this.phoneForm.verificationCode &&
             this.phoneForm.verificationCode.length === 6 &&
             !this.phoneError &&
             !this.codeError
    },
    canGetEmailCode() {
      return this.emailForm.newEmail && !this.emailError
    },
    canSubmitEmail() {
      return this.emailForm.newEmail &&
             this.emailForm.verificationCode &&
             this.emailForm.verificationCode.length === 6 &&
             this.emailForm.newPassword &&
             this.emailForm.newPassword.length >= 6 &&
             !this.emailError &&
             !this.emailCodeError &&
             !this.passwordError
    },
    handleMenuClick(menuKey) {
      if (menuKey === '11') {
        // 设置菜单，切换展开状态
        this.settingsExpanded = !this.settingsExpanded
      } else {
        // 其他菜单，正常切换
        this.activeMenu = menuKey
        this.settingsExpanded = false
        this.activeSettingsOption = ''

        // 如果是我的关注菜单，获取关注数据
        if (menuKey === '7') {
          this.fetchMyFollows()
        }
        if (menuKey === '2') {
          this.loadQaRecords()
        }
        // 如果是供应商名片菜单，获取供应商信息
        if (menuKey === '6') {
          this.fetchSupplierInfo()
        }
        // 如果是我的收藏菜单，获取收藏数据
        if (menuKey === '8') {
          this.activeCollectionTab = 'case'
          this.fetchMyCollections()
        }
        // 如果是案例管理菜单，获取案例数据
        if (menuKey === '15') {
          this.fetchMyCostCases()
        }
        // 如果是发票管理菜单，先获取可申请订单数据
        if (menuKey === '4') {
          this.fetchInvoiceableOrders()
        }
        // 如果是造价师信息菜单，获取造价师信息
        if (menuKey === '14') {
          this.fetchEngineerInfo()
        }
        // 如果是咨询菜单，获取咨询数据
        if (menuKey === '12') {
          this.fetchMessageList()
        }
      }
    },
    loadQaRecords() {
      if (this.qaRecordTab === 'mypost') {
        this.fetchQaMyPosts()
      } else {
        this.onQaMyAnswerSubTabChange(this.qaMyAnswerSubTab)
      }
    },
    switchQaRecordTab(tab) {
      this.qaRecordTab = tab
      this.loadQaRecords()
    },
    async fetchQaMyPosts() {
      try {
        const res = await getMyQuestions({ page: this.qaMyPostsPage, limit: this.qaMyPostsLimit })
        if (res && res.code === 1 && res.data) {
          const list = Array.isArray(res.data.list) ? res.data.list : []
          this.qaMyPosts = list.map(item => ({
            ...item,
            images: Array.isArray(item.images)
              ? item.images
              : (typeof item.images === 'string' && item.images
                ? item.images.split(',').map(s => s.trim()).filter(Boolean)
                : [])
          }))
          this.qaMyPostsTotal = Number(res.data.total || 0)
        } else {
          this.qaMyPosts = []
          this.qaMyPostsTotal = 0
        }
      } catch (e) {
        console.error('获取我的发布失败:', e)
        this.qaMyPosts = []
        this.qaMyPostsTotal = 0
      }
    },
    onQaMyPostsPageChange(page) {
      this.qaMyPostsPage = page
      this.fetchQaMyPosts()
    },
    onQaMyAnswerSubTabChange(tab) {
      this.qaMyAnswerSubTab = tab
      if (tab === 'answered') {
        this.fetchQaMyAnswers()
      } else if (tab === 'income') {
        this.fetchQaIncome()
      } else {
        this.fetchQaHistory()
      }
    },
    async fetchQaMyAnswers() {
      try {
        const res = await getMyAnswers({
          type: 'answered',
          page: this.qaMyAnswersPage,
          limit: this.qaMyAnswersLimit
        })
        if (res && res.code === 1 && res.data) {
          const list = Array.isArray(res.data.list) ? res.data.list : []
          this.qaMyAnswers = list.map(item => ({
            ...item,
            images: Array.isArray(item.images)
              ? item.images
              : (typeof item.images === 'string' && item.images
                ? item.images.split(',').map(s => s.trim()).filter(Boolean)
                : [])
          }))
          this.qaMyAnswersTotal = Number(res.data.total || 0)
        } else {
          this.qaMyAnswers = []
          this.qaMyAnswersTotal = 0
        }
      } catch (e) {
        console.error('获取我的回答失败:', e)
        this.qaMyAnswers = []
        this.qaMyAnswersTotal = 0
      }
    },
    onQaMyAnswersPageChange(page) {
      this.qaMyAnswersPage = page
      this.fetchQaMyAnswers()
    },
    async fetchQaIncome() {
      try {
        const res = await getQAIncome({
          page: this.qaIncomePage,
          limit: this.qaIncomeLimit
        })
        if (res && res.code === 1 && res.data) {
          this.qaIncomeTotal = res.data.total_income || 0
          this.qaIncomeRecords = res.data.records || []
          this.qaIncomeTotalCount = Number(res.data.total || 0)
        } else {
          this.qaIncomeTotal = 0
          this.qaIncomeRecords = []
          this.qaIncomeTotalCount = 0
        }
      } catch (e) {
        console.error('获取问答收入失败:', e)
        this.qaIncomeTotal = 0
        this.qaIncomeRecords = []
        this.qaIncomeTotalCount = 0
      }
    },
    onQaIncomePageChange(page) {
      this.qaIncomePage = page
      this.fetchQaIncome()
    },
    async fetchQaHistory() {
      try {
        const res = await getHistory({
          page: this.qaHistoryPage,
          limit: this.qaHistoryLimit
        })
        if (res && res.code === 1 && res.data) {
          const list = Array.isArray(res.data.list) ? res.data.list : []
          this.qaHistoryList = list
          this.qaHistoryTotal = Number(res.data.total || list.length || 0)
        } else {
          this.qaHistoryList = []
          this.qaHistoryTotal = 0
        }
      } catch (e) {
        console.error('获取历史记录失败:', e)
        this.qaHistoryList = []
        this.qaHistoryTotal = 0
      }
    },
    onQaHistoryPageChange(page) {
      this.qaHistoryPage = page
      this.fetchQaHistory()
    },
    changePhone() {
      this.activeMenu = '16'
      this.settingsExpanded = false
      this.activeSettingsOption = 'phone'
    },
    changeEmail() {
      this.activeMenu = '17'
      this.settingsExpanded = false
      this.activeSettingsOption = 'email'
    },
    // 跳转到造价师注册页面
    goToEngineerRegister() {
      this.$router.push('/engineer')
    },
    // 跳转到供应商注册页面
    goToSupplierRegister() {
      this.$router.push('/supplier')
    },
    deregisterAccount() {
      this.activeSettingsOption = 'deregister'
      this.deregisterModalVisible = true
    },
    closeDeregisterModal() {
      this.deregisterModalVisible = false
    },
    async confirmDeregister() {
      try {
        const { logoff } = await import('@/api/user')
        const response = await logoff()

        if (response && response.code === 1) {
          this.$message.success('账号注销成功')
          this.deregisterModalVisible = false
          // 跳转到登录页面
          this.$router.push('/login')
        } else {
          this.$message.error(response?.msg || '账号注销失败，请重试')
        }
      } catch (error) {
        console.error('注销账号失败:', error)
        this.$message.error('注销失败，请重试')
      }
    },
    logout() {
      this.activeSettingsOption = 'logout'
      this.logoutModalVisible = true
    },
    closeLogoutModal() {
      this.logoutModalVisible = false
    },
    async confirmLogout() {
      try {
        const { logout } = await import('@/api/user')
        const response = await logout()

        if (response && response.code === 1) {
          // 清除所有缓存
          this.clearUserCache()

          this.$message.success('已退出登录')
          this.logoutModalVisible = false

          // 跳转到登录页面
          this.$router.push('/login')
        } else {
          this.$message.error(response?.msg || '退出登录失败，请重试')
        }
      } catch (error) {
        console.error('退出登录失败:', error)
        this.$message.error('退出失败，请重试')
      }
    },
    // 清除用户缓存
    clearUserCache() {
      try {
        // 清除token
        const { removeToken } = require('@/utils/auth')
        removeToken()

        // 清除用户信息
        const { removeUserInfo } = require('@/utils/auth')
        removeUserInfo()

        // 清除Vuex store中的用户数据
        this.$store.dispatch('user/resetToken')

        // 清除其他可能的缓存
        localStorage.removeItem('aaa.userinfo')
        sessionStorage.clear()

        console.log('用户缓存已清除')
      } catch (error) {
        console.error('清除缓存失败:', error)
      }
    },
    validatePhone() {
      const phone = this.phoneForm.newPhone
      if (!phone) {
        this.phoneError = ''
        return
      }

      const phoneRegex = /^1[3-9]\d{9}$/
      if (!phoneRegex.test(phone)) {
        this.phoneError = '请输入正确的手机号格式'
      } else {
        this.phoneError = ''
      }
    },
    getVerificationCode() {
      if (!this.canGetCode) return

      // 模拟发送验证码
      this.$message.success('验证码已发送到新手机号')

      // 开始倒计时
      this.countdown = 60
      this.phoneTimer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          clearInterval(this.phoneTimer)
          this.phoneTimer = null
        }
      }, 1000)
    },
    async submitChangePhone() {
      if (!this.canSubmitPhone) return

      try {
        const { changeMobile } = await import('@/api/user')
        const params = {
          mobile: this.phoneForm.newPhone,
          captcha: this.phoneForm.verificationCode
        }

        const response = await changeMobile(params)
        if (response && response.code === 1) {
          this.$message.success('手机号更换成功')

          // 重置表单
          this.phoneForm = {
            newPhone: '',
            verificationCode: ''
          }
          this.phoneError = ''
          this.codeError = ''
          this.countdown = 0
          if (this.phoneTimer) {
            clearInterval(this.phoneTimer)
            this.phoneTimer = null
          }

          // 刷新用户信息
          this.fetchProfile()

          // 返回个人资料
          this.activeMenu = '1'
        } else {
          this.$message.error(response?.msg || '手机号更换失败，请重试')
        }
      } catch (error) {
        console.error('修改手机号失败:', error)
        this.$message.error('修改失败，请重试')
      }
    },
    validateEmail() {
      const email = this.emailForm.newEmail
      if (!email) {
        this.emailError = ''
        return
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(email)) {
        this.emailError = '请输入正确的邮箱格式'
      } else {
        this.emailError = ''
      }
    },
    validatePassword() {
      const password = this.emailForm.newPassword
      if (!password) {
        this.passwordError = ''
        return
      }

      if (password.length < 6) {
        this.passwordError = '密码长度不能少于6位'
      } else {
        this.passwordError = ''
      }
    },
    getEmailVerificationCode() {
      if (!this.canGetEmailCode) return

      // 模拟发送验证码
      this.$message.success('验证码已发送到新邮箱')

      // 开始倒计时
      this.emailCountdown = 60
      this.emailTimer = setInterval(() => {
        this.emailCountdown--
        if (this.emailCountdown <= 0) {
          clearInterval(this.emailTimer)
          this.emailTimer = null
        }
      }, 1000)
    },
    async submitChangeEmail() {
      if (!this.canSubmitEmail) return

      try {
        const { changeEmail } = await import('@/api/user')
        const params = {
          email: this.emailForm.newEmail,
          captcha: this.emailForm.verificationCode,
          password: this.emailForm.newPassword
        }

        const response = await changeEmail(params)
        if (response && response.code === 1) {
          this.$message.success('邮箱更换成功')

          // 重置表单
          this.emailForm = {
            newEmail: '',
            verificationCode: '',
            newPassword: ''
          }
          this.emailError = ''
          this.emailCodeError = ''
          this.passwordError = ''
          this.emailCountdown = 0
          if (this.emailTimer) {
            clearInterval(this.emailTimer)
            this.emailTimer = null
          }

          // 刷新用户信息
          this.fetchProfile()

          // 返回个人资料
          this.activeMenu = '1'
        } else {
          this.$message.error(response?.msg || '邮箱更换失败，请重试')
        }
      } catch (error) {
        console.error('更换邮箱失败:', error)
        this.$message.error('更换失败，请重试')
      }
    },
    // 上传申诉图片
    async uploadAppealImage() {
      // 创建文件输入元素
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.style.display = 'none'

      input.onchange = async(event) => {
        const file = event.target.files[0]
        if (file) {
          // 检查文件类型
          if (!file.type.startsWith('image/')) {
            this.$message.warning('请选择图片文件')
            return
          }

          // 检查文件大小 (限制5MB)
          if (file.size > 5 * 1024 * 1024) {
            this.$message.warning('图片大小不能超过5MB')
            return
          }

          try {
            // 使用项目中的上传接口
            const { uploadImage } = await import('@/api/user')
            const response = await uploadImage(file)

            if (response && response.code === 1 && response.data) {
              // 回显使用完整URL，提交使用相对路径
              this.appealData.image = response.data.fullurl
              this.appealData.imageUrl = response.data.url
              this.$message.success('图片上传成功')
            } else {
              this.$message.error(response?.msg || '图片上传失败')
            }
          } catch (error) {
            console.error('图片上传失败:', error)
            this.$message.error('图片上传失败，请重试')
          }
        }
      }

      // 触发文件选择
      document.body.appendChild(input)
      input.click()
      document.body.removeChild(input)
    },
    // 提交申诉
    async submitAppeal() {
      // 验证必填字段
      if (!this.appealData.content.trim()) {
        this.$message.warning('请输入申诉内容')
        return
      }

      try {
        const { submitAppeal } = await import('@/api/user')
        const params = {
          content: this.appealData.content.trim(),
          images: this.appealData.imageUrl ? [this.appealData.imageUrl] : []
        }

        const response = await submitAppeal(params)
        if (response && response.code === 1) {
          this.$message.success('申诉提交成功，我们会尽快处理')

          // 重置表单
          this.appealData.content = ''
          this.appealData.image = ''
          this.appealData.imageUrl = ''
        } else {
          this.$message.error(response?.msg || '申诉提交失败，请重试')
        }
      } catch (error) {
        console.error('提交申诉失败:', error)
        this.$message.error('提交失败，请重试')
      }
    },
    // 获取我的案例
    async fetchMyCostCases() {
      try {
        const { getMyCostCases } = await import('@/api/user')
        const response = await getMyCostCases({
          page: this.casePagination.currentPage,
          limit: this.casePagination.pageSize
        })

        if (response && response.code === 1 && response.data) {
          this.costCases = response.data.list || []
          this.casePagination.total = response.data.total || 0
        } else {
          this.costCases = []
          this.casePagination.total = 0
        }
      } catch (error) {
        console.error('获取案例列表失败:', error)
        this.$message.error('获取案例列表失败，请重试')
      }
    },
    // 查看案例详情
    viewCaseDetail(caseItem) {
      this.$router.push({
        path: '/profile/caseDetail',
        query: { case_id: caseItem.id }
      })
    },

    // 切换案例选择状态
    toggleCaseSelection(caseId) {
      const index = this.selectedCases.indexOf(caseId)
      if (index > -1) {
        this.selectedCases.splice(index, 1)
      } else {
        this.selectedCases.push(caseId)
      }
    },
    // 处理案例分页变化
    handleCasePageChange(page) {
      this.casePagination.currentPage = page
      this.fetchMyCostCases()
    },
    // 删除选中的案例
    async deleteSelectedCases() {
      if (this.selectedCases.length === 0) {
        this.$message.warning('请选择要删除的案例')
        return
      }

      try {
        await this.$confirm('确定要删除选中的案例吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const { deleteCostCase } = await import('@/api/user')
        const response = await deleteCostCase({
          case_ids: this.selectedCases.join(',')
        })

        if (response && response.code === 1) {
          this.$message.success('删除成功')
          this.selectedCases = []
          this.fetchMyCostCases()
        } else {
          this.$message.error(response?.msg || '删除失败，请重试')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除案例失败:', error)
          this.$message.error('删除失败，请重试')
        }
      }
    },
    goToShiming() {
      this.$router.push('/profile/shiming')
    },
    // 处理实名认证成功
    handleAuthSuccess() {
      // 重新获取用户信息和实名认证状态
      this.fetchProfile()
      this.fetchRealNameStatus()
    },
    goToBill() {
      // 跳转到账单页面
      this.$router.push('/profile/bill')
    },
    goToTixian() {
      // 跳转到提现页面
      this.$router.push('/profile/tixian')
    },
    goToRechargePolicy() {
      this.$router.push({
        path: '/profile/rechargePolicy',
        query: { type: String(this.balancePolicyType) }
      })
    },
    goToCostqaPublish() {
      this.$router.push({ path: '/costqa/index', query: { tab: 'publish' }})
    },
    uploadCompanyImage() {
      // 创建文件输入元素
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.style.display = 'none'

      input.onchange = (event) => {
        const file = event.target.files[0]
        if (file) {
          // 检查文件类型
          if (!file.type.startsWith('image/')) {
            this.$message.warning('请选择图片文件')
            return
          }

          // 检查文件大小 (限制5MB)
          if (file.size > 5 * 1024 * 1024) {
            this.$message.warning('图片大小不能超过5MB')
            return
          }

          // 创建FileReader读取文件
          const reader = new FileReader()
          reader.onload = (e) => {
            this.companyInfo.companyImage = e.target.result
            this.$message.success('图片上传成功')
          }
          reader.readAsDataURL(file)
        }
      }

      // 触发文件选择
      document.body.appendChild(input)
      input.click()
      document.body.removeChild(input)
    },
    // 保存供应商信息
    async saveCompanyInfo() {
      // 验证必填字段
      if (!this.companyInfo.companyName) {
        this.$message.warning('请输入公司名称')
        return
      }
      if (!this.companyInfo.phone) {
        this.$message.warning('请输入手机号码')
        return
      }

      // 验证手机号格式
      const phoneRegex = /^1[3-9]\d{9}$/
      if (!phoneRegex.test(this.companyInfo.phone)) {
        this.$message.warning('请输入正确的手机号码')
        return
      }

      try {
        const response = await updateSupplierInfo({
          id: this.companyInfo.id,
          company_name: this.companyInfo.companyName,
          main_business: this.companyInfo.mainBusiness,
          region: this.companyInfo.region,
          phone: this.companyInfo.phone,
          other_contact: this.companyInfo.otherContact
        })

        if (response && response.code === 1) {
          this.$message.success('供应商信息保存成功')
          // 保存成功后重新获取供应商信息
          await this.fetchSupplierInfo()
        } else {
          this.$message.error(response?.msg || '保存失败')
        }
      } catch (error) {
        console.error('保存供应商信息失败:', error)
        this.$message.error('保存失败，请重试')
      }
    },
    selectCategory(categoryId) {
      this.selectedCategory = categoryId
    },
    async uploadFeedbackImage() {
      // 创建文件输入元素
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.style.display = 'none'

      input.onchange = async(event) => {
        const file = event.target.files[0]
        if (file) {
          // 检查文件类型
          if (!file.type.startsWith('image/')) {
            this.$message.warning('请选择图片文件')
            return
          }

          // 检查文件大小 (限制5MB)
          if (file.size > 5 * 1024 * 1024) {
            this.$message.warning('图片大小不能超过5MB')
            return
          }

          try {
            // 使用项目中的上传接口
            const { uploadImage } = await import('@/api/user')
            const response = await uploadImage(file)

            if (response && response.code === 1 && response.data) {
              // 回显使用完整URL，提交使用相对路径
              this.feedbackData.image = response.data.fullurl
              this.feedbackData.imageUrl = response.data.url
              this.$message.success('图片上传成功')
            } else {
              this.$message.error(response?.msg || '图片上传失败')
            }
          } catch (error) {
            console.error('图片上传失败:', error)
            this.$message.error('图片上传失败，请重试')
          }
        }
      }

      // 触发文件选择
      document.body.appendChild(input)
      input.click()
      document.body.removeChild(input)
    },
    async submitFeedback() {
      // 验证必填字段
      if (!this.selectedCategory) {
        this.$message.warning('请选择问题分类')
        return
      }
      if (!this.feedbackData.notes.trim()) {
        this.$message.warning('请输入问题描述')
        return
      }

      try {
        // 映射分类ID到API需要的格式
        const categoryMap = {
          'suggestion': 'product_suggestion',
          'bug': 'function_bug',
          'content': 'content_correction',
          'other': 'other'
        }

        const { submitFeedback } = await import('@/api/user')
        const params = {
          feedback_type: categoryMap[this.selectedCategory] || 'other',
          content: this.feedbackData.notes.trim(),
          images: this.feedbackData.imageUrl ? [this.feedbackData.imageUrl] : []
        }

        const response = await submitFeedback(params)
        if (response && response.code === 1) {
          this.$message.success('问题反馈提交成功，我们会尽快处理')

          // 重置表单
          this.selectedCategory = 'bug'
          this.feedbackData.notes = ''
          this.feedbackData.image = ''
          this.feedbackData.imageUrl = ''
        } else {
          this.$message.error(response?.msg || '提交失败，请重试')
        }
      } catch (error) {
        console.error('提交反馈失败:', error)
        this.$message.error('提交失败，请重试')
      }
    },
    selectQuickAmount(amount) {
      this.rechargeAmount = amount
      this.updatePaymentAmount()
    },
    updatePaymentAmount() {
      this.paymentAmount = this.rechargeAmount || 0
    },
    selectPaymentMethod(method) {
      this.selectedPaymentMethod = method
    },
    focusCustomInput() {
      // 点击自定义金额按钮时聚焦输入框
      this.$nextTick(() => {
        const input = this.$el.querySelector('.custom-input')
        if (input) {
          input.focus()
        }
      })
    },
    selectCustomAmount() {
      // 选择自定义金额时清空其他选择
      this.rechargeAmount = this.rechargeAmount || ''
    },
    async handleRecharge() {
      const amount = Number(this.rechargeAmount)
      const paytype = this.selectedPaymentMethod
      if (!amount || !paytype) {
        this.$message.error('请选择正确的金额和支付方式')
        return
      }
      try {
        const res = await rechargeBalance({ amount, paytype })
        // 按你的接口返回结构判断
        if (res && res.code === 1 && res.data && res.data.message) {
          this.$message.success(res.data.message)
          // 刷新余额
          this.fetchProfile && this.fetchProfile()
        } else {
          this.$message.error(res?.msg || '充值失败')
        }
      } catch (e) {
        this.$message.error('充值失败')
      }
    },
    handleWithdraw() {
      if (!this.withdrawPassword || this.withdrawPassword.length !== 6) {
        this.$message.warning('请输入6位提现密码')
        return
      }
      this.$message.success('提现申请已提交，请等待审核')
    },
    closePayment() {
      this.showPayment = false
    },
    confirmPayment() {
      // 确认支付逻辑
      this.$message.success('支付成功！')
      this.showPayment = false
      // 这里可以调用支付确认接口
      // 支付成功后刷新用户余额
      this.fetchProfile()
    },
    // 显示模板选择弹窗
    async showTemplateDialog() {
      if (this.selectedOrders.length === 0) {
        this.$message.warning('请选择要开票的订单')
        return
      }

      // 显示弹窗
      this.showTemplateSelectDialog = true

      // 获取最新的模板数据
      try {
        await this.fetchInvoiceTemplates()
      } catch (error) {
        console.error('获取发票模板失败:', error)
        this.$message.error('获取发票模板失败，请重试')
      }
    },
    // 全选/取消全选订单
    handleSelectAllOrders(val) {
      if (val) {
        this.selectedOrders = this.canApplyOrders.map(order => order.id)
      } else {
        this.selectedOrders = []
      }
      this.isIndeterminate = false
    },
    // 申请发票
    async applyInvoice() {
      if (!this.selectedTemplateId) {
        this.$message.warning('请选择发票模板')
        return
      }

      try {
        const { applyInvoice } = await import('@/api/user')
        const params = {
          order_ids: this.selectedOrders,
          template_id: this.selectedTemplateId
        }

        const response = await applyInvoice(params)
        if (response && response.code === 1) {
          this.$message.success('发票申请提交成功')
          this.showTemplateSelectDialog = false
          this.selectedOrders = []
          this.selectedTemplateId = null
          this.selectAllOrders = false
          this.isIndeterminate = false
          // 刷新订单列表
          this.fetchInvoiceableOrders()
        } else {
          this.$message.error(response.message || '申请失败，请重试')
        }
      } catch (error) {
        console.error('申请发票失败:', error)
        this.$message.error('申请失败，请重试')
      }
    },
    // 取消申请发票
    cancelApplyInvoice() {
      this.showTemplateSelectDialog = false
      this.selectedTemplateId = null
    },
    // 获取我的关注数据
    async fetchMyFollows() {
      try {
        const response = await getMyFollows({
          page: this.followsPagination.currentPage,
          limit: this.followsPagination.pageSize
        })

        if (response && response.code === 1 && response.data) {
          const data = response.data
          this.followsList = data.list.map(item => ({
            id: item.id,
            title: item.case_info.title,
            description: item.case_info.title,
            image: item.case_info.cover_image ? this.getImageUrl(item.case_info.cover_image) : require('@/assets/image/1.jpg'),
            followTime: item.create_date
          }))

          this.followsPagination.total = data.total
        }
      } catch (error) {
        console.error('获取我的关注失败:', error)
        this.$message && this.$message.error('获取我的关注失败')
      }
    },
    // 分页改变时重新获取数据
    handleFollowsPageChange(page) {
      this.followsPagination.currentPage = page
      this.fetchMyFollows()
    },
    // 获取供应商信息
    async fetchSupplierInfo() {
      try {
        const response = await getSupplierInfo()
        if (response && response.code === 1 && response.data) {
          const data = response.data
          this.companyInfo = {
            id: data.id,
            companyImage: data.company_image ? this.getImageUrl(data.company_image) : '',
            companyName: data.company_name || '',
            mainBusiness: data.main_business || '',
            region: data.region || '',
            phone: data.phone || '',
            otherContact: data.other_contact || ''
          }
        }
      } catch (error) {
        console.error('获取供应商信息失败:', error)
        this.$message && this.$message.error('获取供应商信息失败')
      }
    },
    // 获取我的收藏数据
    async fetchMyCollections() {
      try {
        const response = await getMyCollections({
          page: this.collectionsPagination.currentPage,
          limit: this.collectionsPagination.pageSize
        })

        if (response && response.code === 1 && response.data) {
          const data = response.data
          this.collectionsList = data.list.map(item => ({
            id: item.id,
            title: item.case_info.title,
            description: item.case_info.title,
            image: item.case_info.cover_image ? this.getImageUrl(item.case_info.cover_image) : require('@/assets/image/1.jpg'),
            followTime: item.create_date
          }))

          this.collectionsPagination.total = data.total
        }
      } catch (error) {
        console.error('获取我的收藏失败:', error)
        this.$message && this.$message.error('获取我的收藏失败')
      }
    },
    // 分页改变时重新获取收藏数据
    handleCollectionsPageChange(page) {
      this.collectionsPagination.currentPage = page
      this.fetchMyCollections()
    },
    // 切换收藏 Tab
    switchCollectionTab(tab) {
      this.activeCollectionTab = tab
      if (tab === 'case') {
        this.collectionsPagination.currentPage = 1
        this.fetchMyCollections()
      } else if (tab === 'qa') {
        this.qaCollectionsPagination.currentPage = 1
        this.fetchQACollections()
      }
    },
    // 获取问答收藏列表
    async fetchQACollections() {
      try {
        const response = await getFavoriteList({
          page: this.qaCollectionsPagination.currentPage,
          limit: this.qaCollectionsPagination.pageSize
        })

        if (response && response.code === 1 && response.data) {
          const data = response.data
          const list = Array.isArray(data.list) ? data.list : []
          this.qaCollectionsPagination.total = Number(data.total || 0)

          // 字段映射到 QAList 结构
          this.qaCollectionsList = list.map(item => {
            const rawImages = item.images || item.question_info?.images
            let cover = null
            if (Array.isArray(rawImages) && rawImages.length > 0) {
              cover = rawImages[0]
            } else if (typeof rawImages === 'string' && rawImages) {
              const parts = rawImages.split(',').map(s => s.trim()).filter(Boolean)
              cover = parts.length ? parts[0] : null
            }
            const image = cover && this.$getImageUrl ? this.$getImageUrl(cover) : cover || null

            const questionInfo = item.question_info || item
            return {
              id: questionInfo.id || item.id,
              title: questionInfo.title,
              content: questionInfo.content,
              image,
              bounty: questionInfo.reward_amount,
              answerCount: questionInfo.answer_count || 0,
              name: questionInfo.nickname,
              avatar: questionInfo.avatar ? (this.$getImageUrl ? this.$getImageUrl(questionInfo.avatar) : questionInfo.avatar) : null,
              category: questionInfo.category_name,
              time: '',
              type: questionInfo.is_solved === 1 ? 2 : 1
            }
          })
        } else {
          this.qaCollectionsList = []
          this.qaCollectionsPagination.total = 0
        }
      } catch (error) {
        console.error('获取问答收藏列表失败:', error)
        this.$message && this.$message.error('获取问答收藏列表失败')
        this.qaCollectionsList = []
        this.qaCollectionsPagination.total = 0
      }
    },
    // 问答收藏分页改变
    handleQACollectionsPageChange(page) {
      this.qaCollectionsPagination.currentPage = page
      this.fetchQACollections()
    },
    // 打开问答详情
    async openQADetail(item) {
      this.qaDetailVisible = true
      await this.fetchQADetail(item.id)
    },
    // 获取问答详情
    async fetchQADetail(question_id) {
      try {
        const res = await getQuestionDetail(question_id)
        if (res && res.code === 1 && res.data) {
          const d = res.data
          // 处理封面
          let cover = null
          if (Array.isArray(d.images) && d.images.length > 0) cover = d.images[0]
          else if (typeof d.images === 'string' && d.images) {
            const parts = d.images.split(',').map(s => s.trim()).filter(Boolean)
            cover = parts.length ? parts[0] : null
          }
          const image = cover && this.$getImageUrl ? this.$getImageUrl(cover) : cover || null
          // 处理头像
          const avatar = this.$getImageUrl ? this.$getImageUrl(d.avatar) : d.avatar
          // 处理回答列表
          const answers = Array.isArray(d.answers) ? d.answers.map(a => ({
            id: a.id,
            content: a.content,
            image: Array.isArray(a.images) && a.images.length ? (this.$getImageUrl ? this.$getImageUrl(a.images[0]) : a.images[0]) : null,
            is_adopted: Number(a.is_adopted) === 1,
            like_count: a.like_count || 0,
            name: a.nickname,
            avatar: this.$getImageUrl ? this.$getImageUrl(a.avatar) : a.avatar
          })) : []

          this.currentQADetail = {
            id: d.id,
            title: d.title,
            content: d.content,
            image,
            bounty: d.reward_amount,
            answerCount: d.answer_count,
            name: d.nickname,
            avatar,
            category: d.category_name,
            time: '',
            answers,
            lxval: '2' // 收藏列表查看，不显示回复按钮
          }
        } else {
          this.currentQADetail = null
        }
      } catch (error) {
        console.error('获取问答详情失败:', error)
        this.$message && this.$message.error('获取问答详情失败')
        this.currentQADetail = null
      }
    },
    // 关闭问答详情
    closeQADetail() {
      this.qaDetailVisible = false
      this.currentQADetail = null
    },
    // 取消收藏问答
    async handleCancelCollect(item) {
      if (!item.id) return
      try {
        const res = await cancelFavorite(item.id)
        if (res && res.code === 1) {
          this.$message.success('已取消收藏')
          // 从列表中移除该项
          const index = this.qaCollectionsList.findIndex(qa => qa.id === item.id)
          if (index !== -1) {
            this.qaCollectionsList.splice(index, 1)
            // 更新总数
            this.qaCollectionsPagination.total = Math.max(0, this.qaCollectionsPagination.total - 1)
          }
          // 如果当前页没有数据了，且不是第一页，则返回上一页
          if (this.qaCollectionsList.length === 0 && this.qaCollectionsPagination.currentPage > 1) {
            this.qaCollectionsPagination.currentPage--
            this.fetchQACollections()
          }
        } else {
          this.$message.error(res?.msg || '取消收藏失败')
        }
      } catch (error) {
        console.error('取消收藏失败:', error)
        this.$message.error('取消收藏失败')
      }
    },
    // 获取发票模板数据
    async fetchInvoiceTemplates() {
      try {
        const response = await getInvoiceTemplates()
        if (response && response.code === 1 && response.data) {
          const data = response.data
          this.templateList = data.list.map(item => ({
            id: item.id,
            templateName: item.template_name,
            companyName: item.company_name,
            taxNumber: item.taxpayer_id,
            bankName: item.bank_name,
            bankAccount: item.bank_account,
            address: item.address,
            invoice_type_text: item.invoice_type_text
          }))
        }
      } catch (error) {
        console.error('获取发票模板失败:', error)
        this.$message && this.$message.error('获取发票模板失败')
      }
    },
    // 获取可申请发票订单数据
    async fetchInvoiceableOrders() {
      try {
        const response = await getInvoiceableOrders({
          page: this.canApplyOrdersPagination.currentPage,
          limit: this.canApplyOrdersPagination.pageSize
        })
        if (response && response.code === 1 && response.data) {
          const data = response.data
          this.canApplyOrders = data.list.map(item => ({
            id: item.id,
            name: item.order_name,
            amount: item.actual_amount,
            date: item.payment_date
          }))
          this.canApplyOrdersPagination.total = data.total
        }
      } catch (error) {
        console.error('获取可申请订单失败:', error)
        this.$message && this.$message.error('获取可申请订单失败')
      }
    },
    // 分页改变时重新获取可申请订单数据
    handleCanApplyOrdersPageChange(page) {
      this.canApplyOrdersPagination.currentPage = page
      this.fetchInvoiceableOrders()
    },
    // 获取已申请发票订单数据
    async fetchAppliedInvoiceOrders() {
      try {
        const response = await getAppliedInvoiceOrders({
          page: this.appliedListPagination.currentPage,
          limit: this.appliedListPagination.pageSize,
          invoice_status: 0
        })
        if (response && response.code === 1 && response.data) {
          const data = response.data
          this.appliedList = data.list.map(item => ({
            id: item.id,
            applyTime: item.apply_date,
            companyName: item.company_name,
            phone: item.invoice_amount_text,
            address: item.invoice_status_text
          }))
          this.appliedListPagination.total = data.total
        }
      } catch (error) {
        console.error('获取已申请订单失败:', error)
        this.$message && this.$message.error('获取已申请订单失败')
      }
    },
    // 分页改变时重新获取已申请订单数据
    handleAppliedListPageChange(page) {
      this.appliedListPagination.currentPage = page
      this.fetchAppliedInvoiceOrders()
    },
    // 切换发票管理标签页
    switchInvoiceTab(tab) {
      this.invoiceActiveTab = tab
      // 根据标签页切换请求对应接口
      if (tab === 'canApply') {
        this.fetchInvoiceableOrders()
      } else if (tab === 'applied') {
        this.fetchAppliedInvoiceOrders()
      } else if (tab === 'template') {
        this.fetchInvoiceTemplates()
      }
    },
    // 跳转到上传案例页面
    goToUploadCase() {
      this.$router.push('/profile/uploadCase')
    },
    // 跳转到添加发票模板页面
    goToAddTemplate() {
      this.$router.push('/profile/invoice')
    },

    // 获取造价师信息
    async fetchEngineerInfo() {
      try {
        console.log('开始获取造价师信息，用户ID:', this.userInfo.id)
        if (!this.userInfo.id) {
          console.warn('用户ID不存在，无法获取造价师信息')
          return
        }

        console.log('调用getEngineerDetail接口，参数:', this.userInfo.id)
        const response = await getEngineerDetail(this.userInfo.id)
        console.log('getEngineerDetail接口响应:', response)

        if (response && response.code === 1 && response.data) {
          const data = response.data
          console.log('解析造价师数据:', data)
          this.engineerInfo = {
            specialty: data.specialty || '',
            miaoshu: data.miaoshu || '',
            region: data.region || '',
            title: data.title || '',
            engineer_level: Number(data.engineer_level) === 2 ? 2 : 1,
            honorImages: data.honor_wall ? data.honor_wall.split(',').map(img => this.getImageUrl(img)) : [],
            honorWall: data.honor_wall || '',
            // 新增字段
            avatar: data.avatar || '',
            name: data.name || '',
            introduction: data.introduction || '',
            certification_status: data.certification_status || 0,
            certification_text: data.certification_text || '',
            enterprise_certification: data.enterprise_certification || 0,
            enterprise_text: data.enterprise_text || '',
            online_status: data.online_status || 0,
            online_text: data.online_text || '',
            rating: data.rating || '0',
            rating_text: data.rating_text || '0分',
            consultation_count: data.consultation_count || 0,
            work_start_time: data.work_start_time || 0,
            work_start_time_text: data.work_start_time_text || '',
            cases: data.cases || []
          }
          console.log('设置后的engineerInfo:', this.engineerInfo)
        } else {
          console.log('接口返回数据为空或失败')
        }
      } catch (error) {
        console.error('获取造价师信息失败:', error)
        // 不显示错误消息，因为可能是首次访问
      }
    },

    // 上传荣誉证书图片
    uploadHonorImage() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.onchange = async(e) => {
        const file = e.target.files[0]
        if (!file) return

        // 检查文件大小
        if (file.size > 5 * 1024 * 1024) {
          this.$message.error('图片大小不能超过5MB')
          return
        }

        try {
          const response = await uploadImage(file)
          if (response && response.code === 1 && response.data) {
            const imageUrl = this.getImageUrl(response.data.url)
            this.engineerInfo.honorImages.push(imageUrl)
            this.updateHonorWallString()
          } else {
            this.$message.error('图片上传失败')
          }
        } catch (error) {
          console.error('图片上传失败:', error)
          this.$message.error('图片上传失败')
        }
      }
      input.click()
    },

    // 上传个人形象照
    uploadEngineerAvatar() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.onchange = async(e) => {
        const file = e.target.files[0]
        if (!file) return

        if (file.size > 5 * 1024 * 1024) {
          this.$message.error('图片大小不能超过5MB')
          return
        }

        try {
          const response = await uploadImage(file)
          if (response && response.code === 1 && response.data) {
            const avatarPath = response.data.url || response.data.fullurl || ''
            if (!avatarPath) {
              this.$message.error('头像上传失败')
              return
            }
            this.engineerInfo.avatar = avatarPath
            this.$message.success('形象照上传成功')
          } else {
            this.$message.error(response?.msg || '头像上传失败')
          }
        } catch (error) {
          console.error('上传形象照失败:', error)
          this.$message.error('上传失败，请重试')
        }
      }
      input.click()
    },

    // 删除荣誉证书图片
    removeHonorImage(index) {
      this.engineerInfo.honorImages.splice(index, 1)
      this.updateHonorWallString()
    },

    // 更新荣誉墙字符串
    updateHonorWallString() {
      // 将图片URL转换为相对路径
      const honorPaths = this.engineerInfo.honorImages.map(img => {
        if (img.includes('/uploads/')) {
          return img.split('/uploads/')[1]
        }
        return img
      })
      this.engineerInfo.honorWall = honorPaths.join(',')
    },

    // 提交造价师信息
    async submitEngineerInfo() {
      // 表单验证
      if (!this.engineerInfo.specialty.trim()) {
        this.$message.error('请输入专业领域')
        return
      }

      if (!this.engineerInfo.region.trim()) {
        this.$message.error('请输入所在地区')
        return
      }

      if (!this.engineerInfo.title) {
        this.$message.error('请选择职称')
        return
      }

      if (![1, 2].includes(Number(this.engineerInfo.engineer_level))) {
        this.$message.error('请选择造价师级别')
        return
      }

      this.engineerInfoSubmitting = true

      try {
        const response = await updateCostEngineerInfo({
          specialty: this.engineerInfo.specialty,
          miaoshu: this.engineerInfo.miaoshu,
          region: this.engineerInfo.region,
          title: this.engineerInfo.title,
          engineer_level: Number(this.engineerInfo.engineer_level),
          honor_wall: this.engineerInfo.honorWall,
          introduction: this.engineerInfo.introduction,
          avatar: this.engineerInfo.avatar
        })

        if (response && response.code === 1) {
          this.$message.success('造价师信息保存成功')
        } else {
          this.$message.error(response?.msg || '保存失败')
        }
      } catch (error) {
        console.error('保存造价师信息失败:', error)
        this.$message.error('保存失败，请重试')
      } finally {
        this.engineerInfoSubmitting = false
      }
    },

    // 咨询相关方法
    hasMessageRemark(item) {
      return !!(item && item.remark != null && String(item.remark).trim())
    },
    getMessageListDisplayName(item) {
      if (!item) return ''
      const name = item.nickname || ''
      if (!this.hasMessageRemark(item)) return name
      return `${name}（${item.remark}）`
    },
    /** 对话详情 other_user 常无 remark，需与留言列表项合并 */
    mergeSelectedUserWithList(otherUser) {
      const contactId = (otherUser && otherUser.contact_id != null)
        ? otherUser.contact_id
        : this.selectedUserId
      const listItem = this.messageList.find(m => String(m.contact_id) === String(contactId)) || {}
      const prev = this.selectedUser || {}
      let remark = ''
      if (otherUser && otherUser.remark != null && String(otherUser.remark).trim()) {
        remark = String(otherUser.remark).trim()
      } else if (listItem.remark != null && String(listItem.remark).trim()) {
        remark = String(listItem.remark).trim()
      } else if (prev.remark != null && String(prev.remark).trim()) {
        remark = String(prev.remark).trim()
      }
      return {
        ...listItem,
        ...otherUser,
        contact_id: contactId,
        remark
      }
    },
    // 获取留言列表
    async fetchMessageList() {
      try {
        const response = await getMessageBoardList({
          page: 1,
          limit: 20
        })
        if (response && response.code === 1 && response.data) {
          this.messageList = response.data.list || []
          this.consultingPagination.total = response.data.total || 0
          // 默认选择第一个用户
          if (this.messageList.length > 0) {
            this.selectUser(this.messageList[0])
          }
        }
      } catch (error) {
        console.error('获取留言列表失败:', error)
        this.$message.error('获取留言列表失败')
      }
    },

    // 选择用户
    async selectUser(user) {
      this.selectedUserId = user.contact_id
      this.selectedUser = user
      this.messages = []
      this.consultingPagination.page = 1
      this.consultingPagination.hasMore = true
      await this.fetchConversationDetail()
    },

    // 获取对话详情
    async fetchConversationDetail() {
      if (!this.selectedUserId) return

      try {
        this.consultingLoading = true
        const response = await getConversationDetail({
          user_id: this.selectedUserId,
          page: this.consultingPagination.page,
          limit: this.consultingPagination.limit
        })

        if (response && response.code === 1 && response.data) {
          const data = response.data
          // 更新选中用户信息（详情接口 other_user 可能不含 remark，保留列表备注）
          if (data.other_user) {
            this.selectedUser = this.mergeSelectedUserWithList(data.other_user)
          }

          if (this.consultingPagination.page === 1) {
            this.messages = data.messages || []
            // 首次加载时滚动到底部
            this.$nextTick(() => {
              this.scrollToBottom()
            })
          } else {
            // 分页加载时，将新数据添加到前面，并保持滚动位置
            const oldScrollHeight = this.$refs.conversationContent.scrollHeight
            this.messages = [...(data.messages || []), ...this.messages]
            this.$nextTick(() => {
              const newScrollHeight = this.$refs.conversationContent.scrollHeight
              this.$refs.conversationContent.scrollTop = newScrollHeight - oldScrollHeight
            })
          }

          this.consultingPagination.total = data.total || 0
          this.consultingPagination.hasMore = this.messages.length < this.consultingPagination.total
        }
      } catch (error) {
        console.error('获取对话详情失败:', error)
        this.$message.error('获取对话详情失败')
      } finally {
        this.consultingLoading = false
      }
    },

    // 加载更多消息
    async loadMoreMessages() {
      if (this.consultingLoading || !this.consultingPagination.hasMore) return

      this.consultingPagination.page++
      await this.fetchConversationDetail()
    },

    triggerConsultingImageUpload() {
      if (!this.selectedUserId) {
        this.$message.warning('请先选择用户')
        return
      }
      this.$refs.consultingImageInput && this.$refs.consultingImageInput.click()
    },
    triggerConsultingFileUpload() {
      if (!this.selectedUserId) {
        this.$message.warning('请先选择用户')
        return
      }
      this.$refs.consultingFileInput && this.$refs.consultingFileInput.click()
    },
    async handleConsultingImageUpload(event) {
      const file = event.target.files[0]
      if (!file) return
      if (!this.selectedUserId) {
        this.$message.warning('请先选择用户')
        event.target.value = ''
        return
      }
      if (!file.type.startsWith('image/')) {
        this.$message.error('请选择图片文件')
        event.target.value = ''
        return
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message.error('图片大小不能超过10MB')
        event.target.value = ''
        return
      }
      try {
        this.$message.info('正在上传图片...')
        const response = await uploadImage(file)
        if (response && response.code === 1 && response.data) {
          const originalMessage = this.inputMessage
          const imageUrl = response.data.fullurl || response.data.url
          this.inputMessage = `[图片]${imageUrl}`
          await this.sendMessage()
          this.inputMessage = originalMessage
        } else {
          this.$message.error(response?.msg || '图片上传失败')
        }
      } catch (error) {
        console.error('图片上传失败:', error)
        this.$message.error('图片上传失败，请重试')
      } finally {
        const input = event.target
        if (input) input.value = ''
      }
    },
    async handleConsultingFileUpload(event) {
      const file = event.target.files[0]
      if (!file) return
      if (!this.selectedUserId) {
        this.$message.warning('请先选择用户')
        event.target.value = ''
        return
      }
      if (file.size > 50 * 1024 * 1024) {
        this.$message.error('文件大小不能超过50MB')
        event.target.value = ''
        return
      }
      try {
        this.$message.info('正在上传文件...')
        const response = await uploadImage(file)
        if (response && response.code === 1 && response.data) {
          const originalMessage = this.inputMessage
          const fileUrl = response.data.fullurl || response.data.url
          this.inputMessage = `[文件]${file.name} ${fileUrl}`
          await this.sendMessage()
          this.inputMessage = originalMessage
        } else {
          this.$message.error(response?.msg || '文件上传失败')
        }
      } catch (error) {
        console.error('文件上传失败:', error)
        this.$message.error('文件上传失败，请重试')
      } finally {
        const input = event.target
        if (input) input.value = ''
      }
    },
    // 发送消息
    async sendMessage() {
      if (!this.selectedUserId) {
        this.$message.warning('请先选择用户')
        return
      }
      if (!this.inputMessage.trim()) return

      const messageContent = this.inputMessage.trim()
      this.inputMessage = ''

      // 临时添加到消息列表（用户消息）
      const newMessage = {
        id: Date.now(),
        message: messageContent,
        sender_type: 2, // 造价师发送
        is_paid: 0,
        amount: '0.00',
        sender_info: {
          nickname: this.userInfo.nickname || '我',
          avatar: this.userInfo.avatar || ''
        }
      }
      this.messages.push(newMessage)

      // 滚动到底部
      this.$nextTick(() => {
        this.scrollToBottom()
      })

      // 调用发送消息接口
      try {
        const response = await createConversation({
          engineer_id: this.selectedUserId, // 造价师ID
          message: messageContent,
          sender_type: 2, // 造价师发送
          is_paid: 0, // 免费消息
          amount: '0.00' // 金额为0
        })

        if (response && response.code === 1) {
          this.$message.success('发送成功')
          // 刷新对话详情
          await this.fetchConversationDetail()
        } else {
          this.$message.error(response?.msg || '发送失败')
          // 发送失败时移除临时消息
          this.messages.pop()
        }
      } catch (error) {
        console.error('发送消息失败:', error)
        this.$message.error('发送失败，请重试')
        // 发送失败时移除临时消息
        this.messages.pop()
      }
    },

    // 滚动到底部
    scrollToBottom() {
      const container = this.$refs.conversationContent
      if (container) {
        container.scrollTop = container.scrollHeight
      }
    },
    // 解析消息，按换行符分割
    parseMessage(message) {
      if (!message) return []
      // 将 \n 转换为实际换行，然后分割
      return message.split(/\n/).filter(line => line.trim())
    },
    // 判断是否是图片消息
    isImageMessage(message) {
      if (!message) return false
      // 支持 [图片] 前缀格式
      if (message.startsWith('[图片]')) return true
      // 支持直接是图片路径（通过扩展名判断）
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg']
      const trimmed = message.trim()
      return imageExtensions.some(ext => trimmed.toLowerCase().endsWith(ext))
    },
    // 判断是否是文件消息
    isFileMessage(message) {
      return message && message.startsWith('[文件]')
    },
    // 获取消息中的图片URL
    getMessageImageUrl(message) {
      if (this.isImageMessage(message)) {
        let url = message.trim()
        // 如果有 [图片] 前缀，移除它
        if (url.startsWith('[图片]')) {
          url = url.replace('[图片]', '')
        }
        // 如果URL不是完整路径，添加基础路径
        if (url && !url.startsWith('http')) {
          return this.$getImageUrl ? this.$getImageUrl(url) : url
        }
        return url
      }
      return ''
    },
    // 获取文件URL
    getFileUrl(message) {
      if (this.isFileMessage(message)) {
        const parts = message.split(' ')
        if (parts.length > 1) {
          const url = parts[parts.length - 1]
          // 如果URL不是完整路径，添加基础路径
          if (url && !url.startsWith('http')) {
            return this.$getImageUrl ? this.$getImageUrl(url) : url
          }
          return url
        }
      }
      return ''
    },
    // 获取文件名
    getFileName(message) {
      if (this.isFileMessage(message)) {
        const parts = message.split(' ')
        if (parts.length > 1) {
          return parts[0].replace('[文件]', '')
        }
      }
      return '未知文件'
    },
    // 预览图片
    previewImage(url) {
      // 这里可以添加图片预览功能，暂时使用浏览器默认预览
      window.open(url, '_blank')
    },

    // 收费回复相关方法
    // 显示收费回复弹窗
    openRemarkEdit() {
      const contactId = this.selectedUser && this.selectedUser.contact_id != null
        ? this.selectedUser.contact_id
        : this.selectedUserId
      if (!contactId) {
        this.$message.warning('请先选择用户')
        return
      }
      const currentRemark = (this.selectedUser && this.selectedUser.remark) ? String(this.selectedUser.remark) : ''
      this.$prompt('请输入备注名', '修改备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: currentRemark,
        inputPlaceholder: '请输入备注名'
      }).then(({ value }) => {
        const remark = value == null ? '' : String(value).trim()
        this.saveMessageBoardRemark(contactId, remark)
      }).catch(() => {})
    },
    async saveMessageBoardRemark(contactId, remark) {
      try {
        const res = await updateMessageBoardRemark({
          contact_id: contactId,
          remark
        })
        if (res && res.code === 1) {
          this.$message.success(res.msg || '备注已更新')
          if (this.selectedUser) {
            this.$set(this.selectedUser, 'remark', remark)
          }
          const item = this.messageList.find(m => String(m.contact_id) === String(contactId))
          if (item) {
            this.$set(item, 'remark', remark)
          }
        } else {
          this.$message.error((res && res.msg) || '修改备注失败')
        }
      } catch (e) {
        console.error(e)
        this.$message.error('修改备注失败，请重试')
      }
    },
    showChargeReplyModal() {
      if (!this.selectedUserId) {
        this.$message.warning('请先选择用户')
        return
      }
      this.chargeReplyVisible = true
      this.resetChargeReplyForm()
    },

    // 重置收费回复表单
    resetChargeReplyForm() {
      this.chargeReplyForm = {
        message: '',
        amount: '',
        images: [],
        files: []
      }
    },

    // 上传收费图片
    uploadChargeImage() {
      // 检查图片数量限制
      if (this.chargeReplyForm.images.length >= 9) {
        this.$message.warning('最多只能上传9张图片')
        return
      }

      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.onchange = async(e) => {
        const file = e.target.files[0]
        if (!file) return

        // 检查文件大小
        if (file.size > 5 * 1024 * 1024) {
          this.$message.error('图片大小不能超过5MB')
          return
        }

        // 检查文件格式
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']
        if (!allowedTypes.includes(file.type)) {
          this.$message.error('只支持jpg、png格式的图片')
          return
        }

        try {
          const response = await uploadImage(file)
          if (response && response.code === 1 && response.data) {
            this.chargeReplyForm.images.push(response.data.url)
            this.$message.success('图片上传成功')
          } else {
            this.$message.error('图片上传失败')
          }
        } catch (error) {
          console.error('图片上传失败:', error)
          this.$message.error('图片上传失败')
        }
      }
      input.click()
    },

    // 删除收费图片
    removeChargeImage(index) {
      this.chargeReplyForm.images.splice(index, 1)
    },

    // 上传收费文件
    uploadChargeFile() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.zip,.rar'
      input.onchange = async(e) => {
        const file = e.target.files[0]
        if (!file) return

        // 检查文件大小
        if (file.size > 50 * 1024 * 1024) {
          this.$message.error('文件大小不能超过50MB')
          return
        }

        // 检查文件格式
        const fileName = file.name.toLowerCase()
        const fileExtension = fileName.split('.').pop()
        if (!['zip', 'rar'].includes(fileExtension)) {
          this.$message.error('只支持.zip、.rar格式的文件')
          return
        }

        try {
          const response = await uploadImage(file)
          if (response && response.code === 1 && response.data) {
            this.chargeReplyForm.files.push(response.data.url)
            this.$message.success('文件上传成功')
          } else {
            this.$message.error('文件上传失败')
          }
        } catch (error) {
          console.error('文件上传失败:', error)
          this.$message.error('文件上传失败')
        }
      }
      input.click()
    },

    // 删除收费文件
    removeChargeFile(index) {
      this.chargeReplyForm.files.splice(index, 1)
    },

    // 提交收费回复
    async submitChargeReply() {
      if (!this.chargeReplyForm.message.trim() && this.chargeReplyForm.images.length === 0 && this.chargeReplyForm.files.length === 0) {
        this.$message.error('请输入回复内容或上传图片/文件')
        return
      }

      if (!this.chargeReplyForm.amount) {
        this.$message.error('请输入收费金额')
        return
      }

      this.chargeReplySubmitting = true

      try {
        // 构建消息内容
        let messageContent = this.chargeReplyForm.message.trim()

        // 添加图片到消息内容
        if (this.chargeReplyForm.images.length > 0) {
          const imageMessages = this.chargeReplyForm.images.map(url => `[图片]${url}`)
          messageContent = messageContent ? `${messageContent}\n${imageMessages.join('\n')}` : imageMessages.join('\n')
        }

        // 添加文件到消息内容
        if (this.chargeReplyForm.files.length > 0) {
          const fileMessages = this.chargeReplyForm.files.map(url => {
            // 从URL中提取文件名，如果没有则使用默认名称
            const fileName = url.split('/').pop() || '文件'
            return `[文件]${fileName} ${url}`
          })
          messageContent = messageContent ? `${messageContent}\n${fileMessages.join('\n')}` : fileMessages.join('\n')
        }

        // 使用与sendMessage方法一致的逻辑
        const response = await createConversation({
          engineer_id: this.selectedUserId, // 与sendMessage保持一致
          message: messageContent,
          sender_type: 2, // 造价师发送
          is_paid: 1, // 付费消息
          amount: this.chargeReplyForm.amount
        })

        if (response && response.code === 1) {
          this.$message.success('收费回复发送成功')
          this.chargeReplyVisible = false
          this.resetChargeReplyForm()
          // 刷新对话详情
          await this.fetchConversationDetail()
        } else {
          this.$message.error(response?.msg || '发送失败')
        }
      } catch (error) {
        console.error('发送收费回复失败:', error)
        this.$message.error('发送失败，请重试')
      } finally {
        this.chargeReplySubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.profile-container {
  height: calc(100vh - var(--navbar-total-height, 80px));
  height: calc(100dvh - var(--navbar-total-height, 80px));
  background: #F5F5F5;
  padding: 20px;
}

/* 外层白色容器 */
.con-box{
 width: var(--page-inner-ratio, 80%);
  background: #fff;
  margin: 0 auto;
  border-radius: 10px;
}
.profile-wrapper {
  display: flex;
  height: 100%;
  overflow: hidden;
}

/* 左侧导航 */
.profile-sidebar {
  width: 280px;
  background: #ECF2FF;
  padding: 20px 0;
  border-right: 1px solid #F2F3F5;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: calc(100vh - var(--navbar-total-height, 80px) - 100px);
  height: calc(100dvh - var(--navbar-total-height, 80px) - 100px);
  /* 隐藏滚动条 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.profile-sidebar::-webkit-scrollbar {
  display: none; /* Chrome, Safari and Opera */
}

.sidebar-header {
  display: flex;
  align-items: center;
  padding: 20px;
  background: #fff;
}

.header-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.user-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px 20px;
  margin-bottom: 20px;
  gap: 8px;
}

.user-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.user-name {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.sidebar-menu {
  padding: 0 10px;
  flex: 1;
  overflow-y: auto;
  /* 隐藏滚动条 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.sidebar-menu::-webkit-scrollbar {
  display: none; /* Chrome, Safari and Opera */
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  margin: 4px 0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.menu-item:hover {
  background: #F0F9FF;
}

.menu-item.active {
  background: #fff;
  color: #1E80FF;
}

.menu-icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
}

.menu-label {
  font-size: 14px;
  color: #606266;
  flex: 1;
}

.menu-item.active .menu-label {
  color: #1E80FF;
  font-weight: 600;
}

.expand-icon {
  width: 12px;
  margin-left: auto;
  transition: transform 0.3s;
}

.expand-icon.expanded {
  transform: rotate(180deg);
}

.settings-options {
  background: #F8F9FA;
  border-radius: 8px;
  margin: 8px 0;
  padding: 8px 0;
  animation: slideDown 0.3s ease-out;
}

.settings-option {
  padding: 12px 20px;
  font-size: 14px;
  color: #303133;
  cursor: pointer;
  transition: all 0.3s;
  border-left: 3px solid transparent;
}

.settings-option:hover {
  background: #E3F2FD;
  color: #1E80FF;
}

.settings-option.active-option {
  color: #1E80FF;
  font-weight: 600;
  border-left-color: #1E80FF;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 更换手机号样式 */
.change-phone-section {
  padding: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  min-height: 400px;
}

.form-container {
  background: #fff;
  border-radius: 8px;
  padding: 40px;
  width: 100%;
  max-width: 600px;
}

.form-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  text-align: center;
  margin-bottom: 30px;
}

.form-content {
  width: 100%;
}

.form-group {
  margin-bottom: 24px;
}

.form-label {
  display: block;
  font-size: 14px;
  color: #303133;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-input {
  width: 100%;
}

.form-input >>> .el-input__inner {
  height: 44px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  font-size: 14px;
  padding: 0 12px;
  transition: border-color 0.3s;
}

.form-input >>> .el-input__inner:focus {
  border-color: #1E80FF;
}

.verification-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.verification-input {
  flex: 1;
}

.verification-input >>> .el-input__inner {
  height: 44px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  font-size: 14px;
  padding: 0 12px;
  transition: border-color 0.3s;
}

.verification-input >>> .el-input__inner:focus {
  border-color: #1E80FF;
}

.get-code-btn {
  height: 44px;
  padding: 0 16px;
  font-size: 14px;
  color: #1E80FF;
  border: none;
  background: transparent;
  transition: all 0.3s;
  white-space: nowrap;
  cursor: pointer;
}

.get-code-btn:hover:not(:disabled) {
  color: #409EFF;
}

.get-code-btn:disabled {
  color: #C0C4CC;
  cursor: not-allowed;
}

.error-message {
  color: #F56C6C;
  font-size: 12px;
  margin-top: 5px;
}

.form-actions {
  margin-top: 32px;
}

.confirm-btn {
  width: 50%;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  background: #1E80FF;
  border: none;
  transition: all 0.3s;
}

.confirm-btn:hover:not(:disabled) {
  background: #409EFF;
}

.confirm-btn:disabled {
  background: #C0C4CC;
  cursor: not-allowed;
}

/* 更换邮箱样式 */
.change-email-section {
  padding: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  min-height: 400px;
}

.change-email-section .form-container {
  background: #fff;
  border-radius: 8px;
  padding: 40px;
  width: 100%;
  max-width: 600px;
}

.change-email-section .form-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  text-align: center;
  margin-bottom: 30px;
}

.change-email-section .form-content {
  width: 100%;
}

.change-email-section .form-group {
  margin-bottom: 24px;
}

.change-email-section .form-label {
  display: block;
  font-size: 14px;
  color: #303133;
  margin-bottom: 8px;
  font-weight: 500;
}

.change-email-section .form-input {
  width: 100%;
}

.change-email-section .form-input >>> .el-input__inner {
  height: 44px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  font-size: 14px;
  padding: 0 12px;
  transition: border-color 0.3s;
}

.change-email-section .form-input >>> .el-input__inner:focus {
  border-color: #1E80FF;
}

.change-email-section .verification-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.change-email-section .verification-input {
  flex: 1;
}

.change-email-section .verification-input >>> .el-input__inner {
  height: 44px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  font-size: 14px;
  padding: 0 12px;
  transition: border-color 0.3s;
}

.change-email-section .verification-input >>> .el-input__inner:focus {
  border-color: #1E80FF;
}

.change-email-section .get-code-btn {
  height: 44px;
  padding: 0 16px;
  font-size: 14px;
  color: #1E80FF;
  border: none;
  background: transparent;
  transition: all 0.3s;
  white-space: nowrap;
  cursor: pointer;
}

.change-email-section .get-code-btn:hover:not(:disabled) {
  color: #409EFF;
}

.change-email-section .get-code-btn:disabled {
  color: #C0C4CC;
  cursor: not-allowed;
}

.change-email-section .error-message {
  color: #F56C6C;
  font-size: 12px;
  margin-top: 5px;
}

.change-email-section .form-actions {
  margin-top: 32px;
}

.change-email-section .confirm-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  background: #1E80FF;
  border: none;
  transition: all 0.3s;
}

.change-email-section .confirm-btn:hover:not(:disabled) {
  background: #409EFF;
}

.change-email-section .confirm-btn:disabled {
  background: #C0C4CC;
  cursor: not-allowed;
}

/* 注销账号弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: fadeIn 0.3s ease-out;
}

.deregister-modal {
  background: #fff;
  border-radius: 8px;
  width: 400px;
  max-width: 90vw;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease-out;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #F0F0F0;
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #909399;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s;
}

.close-btn:hover {
  color: #606266;
}

.modal-content {
  padding: 24px;
}

.modal-message {
  font-size: 16px;
  color: #303133;
  margin: 0;
  text-align: center;
  line-height: 1.5;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px 24px;
}

.cancel-btn {
	width: 50%;
  padding: 8px 24px;
  font-size: 14px;
  color: #606266;
  background: #F5F7FA;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.cancel-btn:hover {
  background: #EBEEF5;
  border-color: #C0C4CC;
}

.confirm-btn {
  padding: 8px 24px;
  font-size: 14px;
  color: #fff;
  background: #1E80FF;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.confirm-btn:hover {
  background: #409EFF;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* 退出登录弹窗样式 */
.logout-modal {
  background: #fff;
  border-radius: 8px;
  width: 400px;
  max-width: 90vw;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease-out;
}

.logout-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #F0F0F0;
}

.logout-modal .modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin: 0;
}

.logout-modal .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #909399;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s;
}

.logout-modal .close-btn:hover {
  color: #606266;
}

.logout-modal .modal-content {
  padding: 24px;
}

.logout-modal .modal-message {
  font-size: 16px;
  color: #303133;
  margin: 0;
  text-align: center;
  line-height: 1.5;
}

.logout-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px 24px;
}

.logout-modal .cancel-btn {
  width: 50%;
  padding: 8px 24px;
  font-size: 14px;
  color: #606266;
  background: #F5F7FA;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.logout-modal .cancel-btn:hover {
  background: #EBEEF5;
  border-color: #C0C4CC;
}

.logout-modal .confirm-btn {
  width: 50%;
  padding: 8px 24px;
  font-size: 14px;
  color: #fff;
  background: #1E80FF;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.logout-modal .confirm-btn:hover {
  background: #409EFF;
}

/* 右侧内容区 */
.profile-content {
  flex: 1;
  background: #fff;
  padding: 24px;
  overflow-y: auto;
  height: calc(100vh - var(--navbar-total-height, 80px) - 100px);
  height: calc(100dvh - var(--navbar-total-height, 80px) - 100px);
  /* 隐藏滚动条 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.profile-content::-webkit-scrollbar {
  display: none; /* Chrome, Safari and Opera */
}

.content-section {
  max-width: 900px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
}

.avatar-section {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.current-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 16px;
}

.upload-btn {
  height: 36px;
  padding: 0 20px;
  border-radius: 6px;
  background: #ECF2FF;
  border-color: #ECF2FF;
  color: #0F71E3;
}

.verification-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 32px;
  padding: 16px;
  border-radius: 8px;
}

.verification-row {
  display: flex;
  align-items: center;
}

.shield-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.user-status {
  font-size: 14px;
  color: #606266;
  margin-right: 16px;
}

.verification-text {
  font-size: 14px;
  color: #606266;
  margin-right: 8px;
}

.verification-status {
  font-size: 14px;
  color: #F56C6C;
  margin-right: 16px;
}

.verify-link {
  font-size: 14px;
  color: #1E80FF;
  text-decoration: none;
}

.verify-link:hover {
  color: #0F71E3;
}

.verify-link.disabled {
  color: #909399;
  cursor: not-allowed;
}

.verify-link.disabled:hover {
  color: #909399;
}

/* 实名认证状态样式 */
.verification-status.status-pending {
  color: #909399;
}

.verification-status.status-reviewing {
  color: #E6A23C;
}

.verification-status.status-approved {
  color: #67C23A;
}

.verification-status.status-rejected {
  color: #F56C6C;
}

.verification-status.status-unknown {
  color: #909399;
}

.form-section {
  margin-bottom: 32px;
}

.form-item {
  margin-bottom: 24px;
}

.form-label {
  display: block;
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
  font-weight: 500;
}

.upgrade-section {
  margin-bottom: 32px;
  padding: 24px;
  background: #f8f9fa;
  border-radius: 8px;
}

.upgrade-section .section-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
}

.upgrade-section .upgrade-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.upgrade-section .upgrade-card {
  display: flex;
  align-items: center;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #e4e7ed;
}

.upgrade-section .upgrade-card:hover {
  border-color: #0f6fe2;
  box-shadow: 0 2px 8px rgba(15, 111, 226, 0.1);
  transform: translateY(-2px);
}

.upgrade-section .upgrade-card .upgrade-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f8ff;
  border-radius: 8px;
  margin-right: 16px;
}

.upgrade-section .upgrade-card .upgrade-icon i {
  font-size: 24px;
  color: #0f6fe2;
}

.upgrade-section .upgrade-card .upgrade-content {
  flex: 1;
}

.upgrade-section .upgrade-card .upgrade-content .upgrade-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 4px;
}

.upgrade-section .upgrade-card .upgrade-content .upgrade-desc {
  font-size: 14px;
  color: #909399;
}

.upgrade-section .upgrade-card .upgrade-arrow {
  color: #909399;
  font-size: 18px;
}

.save-btn {
  width: 100%;
  height: 40px;
  font-size: 16px;
  border-radius: 6px;
}

.content-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
}

.placeholder-text {
  font-size: 18px;
  color: #909399;
}

/* 详情弹窗样式 */
.detail-body {
  padding: 20px;
}

.detail-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
}

.qa-card-image {
  margin: 20px 0;
}

.qa-card-image img {
  width: 100%;
  border-radius: 8px;
}

.detail-section {
  margin-top: 30px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
}

.answer-item {
  background: #F8F9FA;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
}

.answer-user {
  display: flex;
  align-items: center;
  gap: 8px;
}

.answer-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.answer-name {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

.answer-actions {
  display: flex;
  gap: 16px;
}

.adopt, .reject {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.adopt {
  background: #E6F4FF;
  color: #1E80FF;
}

.adopt.active {
  background: #1E80FF;
  color: #fff;
}

.reject {
  background: #FFF2E8;
  color: #E6A23C;
}

.reject.active {
  background: #E6A23C;
  color: #fff;
}

.action-icon {
  width: 16px;
  height: 16px;
}

/* 问答列表样式 */
.qa-list {
  padding: 0;
}

.qa-card {
  background: #fff;
  border-radius: 10px;
  padding: 12px 14px 10px;
  box-shadow: 0 2px 8px rgba(31, 35, 41, 0.06);
  margin-bottom: 16px;
  cursor: pointer;
}

.qa-card-header {
  display: flex;
  align-items: center;
}

.reply-icon {
  width: 18px;
  height: 18px;
  margin-top: 2px;
  margin-right: 8px;
}

.qa-head {
  flex: 1;
}

.qa-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.name {
  color: #606266;
  font-weight: 600;
  font-size: 14px;
}

.status {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  background: #EFF2F5;
  color: #8A8F99;
}

.status.solved {
  background: #E6F4FF;
  color: #1E80FF;
}

.status.unsolved {
  background: #EFF2F5;
  color: #8A8F99;
}

.category {
  font-size: 12px;
  color: #F29E38;
}

.qa-card-right {
  color: #1E80FF;
  font-size: 12px;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 8px;
}

.qa-card-image img {
  width: 100%;
  border-radius: 8px;
  margin: 10px 0;
}

.qa-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.qa-card-footer .bounty {
  color: #FF4800;
  font-size: 18px;
}

.right-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  color: #909399;
  font-size: 12px;
}

.right-actions .reply {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #1E80FF;
  cursor: pointer;
}

.right-actions .reply .reply-icon {
  width: 14px;
  height: 14px;
  margin: 0;
}

/* 我的余额样式 */
.balance-section {
  max-width: 100%;
}

.balance-header {
  background: linear-gradient(135deg, #1E80FF 0%, #0F71E3 100%);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
}

.balance-info {
  display: flex;
  flex-direction: column;
}

.balance-label {
  font-size: 16px;
  margin-bottom: 8px;
  opacity: 0.9;
}

.balance-amount {
  font-size: 32px;
  font-weight: 700;
  line-height: 1;
}

.balance-actions {
  display: flex;
  gap: 12px;
}

.action-btn {
  background: #fff;
  color: #1E80FF;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  border: none;
  font-size: 14px;
}

.action-btn:hover {
  background: #f0f9ff;
  transform: translateY(-2px);
}

.balance-policy-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 100%;
  padding: 14px 18px;
  margin-bottom: 24px;
  background: #fafbfc;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease, color 0.2s ease;
}

.balance-policy-link:hover {
  border-color: #1e80ff;
  background: #f5faff;
  color: #1e80ff;
}

.balance-policy-link .el-icon-arrow-right {
  font-size: 14px;
  color: #c0c4cc;
}

.balance-policy-link:hover .el-icon-arrow-right {
  color: #1e80ff;
}

.recharge-section {
  margin-bottom: 24px;
}

.recharge-label {
  font-size: 16px;
  color: #303133;
  margin-bottom: 16px;
  font-weight: 600;
}

.amount-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.amount-btn {
  background: #F5F5F5;
  border: 1px solid #E4E7ED;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #1E80FF;
  cursor: pointer;
  transition: all 0.3s;
}

.amount-btn:hover {
  background: #E3F2FD;
  border-color: #1E80FF;
}

.amount-btn.active {
  background: #1E80FF;
  color: #fff;
  border-color: #1E80FF;
}

.form-group {
  margin-bottom: 24px;
}

.form-group .form-label {
  font-size: 16px;
  color: #303133;
  margin-bottom: 12px;
  font-weight: 500;
}

.amount-input,
.password-input {
  width: 100%;
}

.amount-input .el-input__inner,
.password-input .el-input__inner {
  height: 48px;
  border-radius: 8px;
  border: 1px solid #E4E7ED;
  font-size: 16px;
  padding: 0 16px;
}

.amount-input .el-input__inner:focus,
.password-input .el-input__inner:focus {
  border-color: #1E80FF;
}

.payment-section {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  margin-top: 24px;
}

.qr-code-container {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 20px;
}

.qr-code {
  width: 120px;
  height: 120px;
  background: #000;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #E4E7ED;
}

.qr-placeholder {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}

.payment-info {
  flex: 1;
}

.amount-due {
  font-size: 18px;
  color: #303133;
  margin-bottom: 16px;
}

.amount-text {
  color: #F56C6C;
  font-weight: 700;
  font-size: 20px;
}

.payment-methods {
  display: flex;
  align-items: center;
  gap: 12px;
}

.payment-icon {
  width: 24px;
  height: 24px;
}

.payment-text {
  color: #909399;
  font-size: 14px;
}

.agreement-text {
  text-align: center;
  color: #909399;
  font-size: 12px;
  margin-top: 16px;
}

.agreement-link {
  color: #1E80FF;
  text-decoration: none;
}

.agreement-link:hover {
  text-decoration: underline;
}

/* 优化后的余额页面样式 */
.amount-input-container {
  position: relative;
  margin-bottom: 16px;
}

.currency-symbol {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #909399;
  font-size: 16px;
  z-index: 1;
}

.amount-input .el-input__inner {
  padding-left: 30px;
}

.quick-amounts {
  margin-top: 12px;
}

.quick-amount-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
}

/* 支付方式选择样式 */
.payment-methods-section {
  margin-top: 24px;
}

.payment-label {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 12px;
}

.payment-methods {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.payment-method {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border: 2px solid #E0E0E0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fff;
  min-width: 120px;
  position: relative;
}

.payment-method:hover {
  border-color: #1890FF;
  background: #f0f9ff;
}

.payment-method.active {
  border-color: #1890FF;
  background: #f0f9ff;
}

.payment-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.yue-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f39800;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.payment-name {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.payment-check {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 16px;
  height: 16px;
  background: #1890FF;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
}

.recharge-actions {
  margin-top: 24px;
  text-align: center;
}

.recharge-btn {
  width: 200px;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
}

/* 自定义金额按钮样式 */
.custom-amount-btn {
  position: relative;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-input {
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  outline: none;
  padding: 0 12px;
}

.custom-input::placeholder {
  color: #999;
  font-size: 14px;
}

.custom-amount-btn.active .custom-input {
  color: #1890FF;
}

/* 二维码样式优化 */
.qr-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 200px;
  background: #f8f9fa;
  border: 2px dashed #ddd;
  border-radius: 8px;
  margin: 0 auto;
}

.qr-icon {
  width: 48px;
  height: 48px;
  margin-bottom: 12px;
}

.qr-text {
  font-size: 14px;
  color: #666;
  text-align: center;
}

.wechat-qr {
  border-color: #07C160;
  background: #f0f9f0;
}

.alipay-qr {
  border-color: #1677FF;
  background: #f0f9ff;
}

.payment-method-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.payment-tips {
  font-size: 12px;
  color: #999;
  text-align: center;
  margin-top: 8px;
}

.payment-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 20px;
}

.quick-amount-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.quick-amount-btn {
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
  border: 1px solid #E4E7ED;
  background: #fff;
  color: #606266;
  transition: all 0.3s;
}

.quick-amount-btn:hover {
  border-color: #1E80FF;
  color: #1E80FF;
}

.quick-amount-btn.active {
  background: #1E80FF;
  border-color: #1E80FF;
  color: #fff;
}

.action-buttons {
  display: flex;
  gap: 16px;
  margin: 24px 0;
}

.recharge-btn,
.withdraw-btn {
  flex: 1;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
}

.payment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #E4E7ED;
}

.payment-header h3 {
  margin: 0;
  font-size: 18px;
  color: #303133;
}

.close-btn {
  font-size: 24px;
  color: #909399;
  padding: 0;
  width: 32px;
  height: 32px;
  line-height: 1;
}

.qr-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.qr-icon {
  font-size: 32px;
  margin-bottom: 8px;
}

.qr-text {
  font-size: 12px;
  color: #909399;
}

.payment-tips {
  margin-top: 16px;
}

.tip-item {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}

.balance-records {
  margin-top: 32px;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.records-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.records-header h3 {
  margin: 0;
  font-size: 18px;
  color: #303133;
}

.refresh-btn {
  color: #1E80FF;
  font-size: 14px;
}

.records-tabs {
  display: flex;
  border-bottom: 1px solid #E4E7ED;
  margin-bottom: 16px;
}

.tab-item {
  padding: 12px 24px;
  cursor: pointer;
  color: #606266;
  font-size: 14px;
  border-bottom: 2px solid transparent;
  transition: all 0.3s;
}

.tab-item:hover {
  color: #1E80FF;
}

.tab-item.active {
  color: #1E80FF;
  border-bottom-color: #1E80FF;
}

.records-list {
  max-height: 300px;
  overflow-y: auto;
}

.record-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.record-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #F8F9FA;
  border-radius: 8px;
}

.record-info {
  display: flex;
  flex-direction: column;
}

.record-type {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

.record-time {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.record-amount {
  font-size: 16px;
  font-weight: 600;
}

.record-amount.positive {
  color: #67C23A;
}

.record-amount.negative {
  color: #F56C6C;
}

/* 账单入口样式 */
.bill-entry {
  margin-top: 32px;
}

.bill-card {
  display: flex;
  align-items: center;
  padding: 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s;
}

.bill-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.bill-icon {
  font-size: 32px;
  margin-right: 16px;
}

.bill-info {
  flex: 1;
}

.bill-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 4px;
}

.bill-desc {
  font-size: 14px;
  color: #909399;
}

.bill-arrow {
  font-size: 20px;
  color: #C0C4CC;
}

/* 发票管理样式 */
.invoice-section {
  max-width: 1200px;
}

.invoice-tabs {
  display: flex;
  border-bottom: 1px solid #E4E7ED;
  margin-bottom: 24px;
}

.invoice-tabs .tab-item {
  padding: 12px 24px;
  cursor: pointer;
  color: #606266;
  font-size: 16px;
  border-bottom: 2px solid transparent;
  transition: all 0.3s;
}

.invoice-tabs .tab-item:hover {
  color: #1E80FF;
}

.invoice-tabs .tab-item.active {
  color: #1E80FF;
  border-bottom-color: #1E80FF;
  font-weight: 600;
}

/* 可申请标签页样式 */
.table-header {
  display: flex;
  background: #F8F9FA;
  border-radius: 8px 8px 0 0;
  padding: 16px 0;
  margin-bottom: 0;
}

.header-cell {
  flex: 1;
  text-align: center;
  font-weight: 600;
  color: #303133;
  font-size: 14px;
}

.table-body {
  border: 1px solid #E4E7ED;
  border-top: none;
  border-radius: 0 0 8px 8px;
}

.table-row {
  display: flex;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #F0F0F0;
}

.table-row:last-child {
  border-bottom: none;
}

.row-checkbox {
  width: 60px;
  display: flex;
  justify-content: center;
}

.order-radio {
  margin: 0;
}

.row-cell {
  flex: 1;
  text-align: center;
  font-size: 14px;
}

.order-name {
  color: #303133;
}

.payment-amount {
  color: #1E80FF;
  font-weight: 600;
}

.order-date {
  color: #909399;
}

.action-section {
  margin-top: 24px;
  text-align: center;
}

.create-invoice-btn {
  width: 200px;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
}

/* 已申请和发票模板标签页样式 */
.applied-list,
.template-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.applied-item {
  padding: 20px;
  background: transparent;
  border-radius: 8px;
  border: 1px solid #E4E7ED;
}

.template-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: transparent;
  border-radius: 8px;
  border: 1px solid #E4E7ED;
}

.applied-info {
  width: 100%;
}

.applied-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.applied-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.applied-row-three {
  display: flex;
  gap: 40px;
  margin-bottom: 0;
}

.template-info {
  flex: 1;
}

.invoice-section .info-row {
  display: flex;
  margin-bottom: 8px;
}

.invoice-section .info-row:last-child {
  margin-bottom: 0;
}

.invoice-section .info-label {
  font-size: 14px;
  color: #606266;
  min-width: 100px;
}

.invoice-section .info-value {
  font-size: 14px;
  color: #303133;
  flex: 1;
}

.applied-header .applied-status {
  margin-left: 0;
}

.status-text {
  color: #1E80FF;
  font-size: 14px;
  font-weight: 600;
}

/* 发票模板特殊布局样式 */
.template-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.add-template-btn {
  height: 40px;
  padding: 0 24px;
  font-size: 14px;
  border-radius: 6px;
  background: #1E80FF;
  border-color: #1E80FF;
}

.add-template-btn:hover {
  background: #0F71E3;
  border-color: #0F71E3;
}

.template-info .info-row:first-child {
  border-bottom: 1px solid #E4E7ED;
  padding-bottom: 12px;
  margin-bottom: 12px;
}

.template-row-two {
  display: flex;
  gap: 40px;
  margin-bottom: 8px;
}

.template-row-three {
  display: flex;
  gap: 40px;
  margin-bottom: 0;
}

.info-group {
  display: flex;
  flex: 1;
}

.info-group .info-label {
  min-width: auto;
  margin-right: 8px;
}

.info-group .info-value {
  flex: 1;
}

/* 开通会员样式 */
.membership-section {
  max-width: 900px;
}

/* 会员信息显示样式 */
.membership-info-section {
  max-width: 900px;
}

.membership-status-card {
  background: linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%);
  border-radius: 12px;
  padding: 32px;
  margin-bottom: 32px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 2px solid #FF9800;
}

.status-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 2px solid rgba(255, 152, 0, 0.2);
}

.vip-icon {
  width: 60px;
  height: 60px;
  flex-shrink: 0;
}

.status-title h2 {
  font-size: 28px;
  font-weight: 700;
  color: #FF6F00;
  margin: 0 0 8px 0;
}

.status-desc {
  font-size: 14px;
  color: #E65100;
  margin: 0;
}

.membership-details {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.detail-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  font-size: 16px;
}

.detail-item.highlight {
  background: linear-gradient(135deg, #FFE082 0%, #FFCC02 100%);
  font-weight: 600;
}

.detail-label {
  color: #666;
  min-width: 120px;
  font-weight: 500;
}

.detail-item.highlight .detail-label {
  color: #E65100;
}

.detail-value {
  color: #333;
  font-weight: 600;
}

.detail-item.highlight .detail-value {
  color: #E65100;
  font-size: 18px;
}

.renewal-section {
  text-align: center;
  margin-top: 32px;
}

.renewal-button {
  padding: 12px 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
}

.membership-card {
  background: linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 32px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 20%;
  border: 2px solid #0F71E3;
}

.card-title {
  font-size: 24px;
  font-weight: 600;
  color: #1976D2;
  margin-bottom: 16px;
}

.price-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.current-price {
  font-size: 36px;
  font-weight: 700;
  color: #F44336;
}

.original-price {
  font-size: 20px;
  color: #9E9E9E;
  text-decoration: line-through;
}

.benefits-section {
  margin-bottom: 32px;
}

.benefits-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
}

.benefits-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.benefit-item {
  display: flex;
  align-items: center;
  padding: 16px;
  background: #E3F2FD;
  border-radius: 8px;
  border: 1px solid #BBDEFB;
}

.benefit-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
  flex-shrink: 0;
}

.benefit-text {
  font-size: 14px;
  color: #303133;
  line-height: 1.5;
}

.payment-section {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #E4E7ED;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.qr-code-container {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 16px;
}

.qr-code {
  width: 120px;
  height: 120px;
  background: #F5F5F5;
  border: 1px solid #E4E7ED;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.qr-placeholder {
  font-size: 12px;
  color: #9E9E9E;
}

.payment-info {
  flex: 1;
}

.amount-due {
  font-size: 16px;
  color: #303133;
  margin-bottom: 12px;
}

.amount-text {
  font-size: 20px;
  font-weight: 600;
  color: #F44336;
}

.payment-methods {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.payment-icon {
  width: 20px;
  height: 20px;
}

.payment-text {
  font-size: 14px;
  color: #606266;
}

.agreement-text {
  font-size: 12px;
  color: #9E9E9E;
  text-align: center;
  margin-bottom: 24px;
}

.payment-button-container {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.pay-button {
  height: 48px;
  padding: 0 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 24px;
  background: linear-gradient(135deg, #1E80FF 0%, #0F71E3 100%);
  border: none;
  box-shadow: 0 4px 12px rgba(30, 128, 255, 0.3);
  transition: all 0.3s ease;
}

.pay-button:hover {
  background: linear-gradient(135deg, #0F71E3 0%, #0E61D0 100%);
  box-shadow: 0 6px 16px rgba(30, 128, 255, 0.4);
  transform: translateY(-2px);
}

.pay-button:active {
  transform: translateY(0);
}

.agreement-link {
  color: #1E80FF;
  text-decoration: none;
}

.agreement-link:hover {
  text-decoration: underline;
}

/* 供应商名片样式 */
.supplier-card-section {
  max-width: 600px;
}

.company-image-section {
  margin-bottom: 32px;
}

.image-label {
  font-size: 16px;
  color: #303133;
  margin-bottom: 16px;
  font-weight: 600;
}

.image-upload {
  display: flex;
  justify-content: flex-start;
}

.image-placeholder {
  width: 120px;
  height: 120px;
  background: #F5F5F5;
  border: 2px dashed #D9D9D9;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
}

.image-placeholder:hover {
  border-color: #1E80FF;
  background: #F0F9FF;
}

.placeholder-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.image-preview {
  position: relative;
  width: 100%;
  height: 100%;
}

.preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
  border-radius: 6px;
}

.image-placeholder:hover .image-overlay {
  opacity: 1;
}

.change-text {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}

.company-form {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 24px;
}

.form-group:last-of-type {
  margin-bottom: 32px;
}

.form-label {
  display: block;
  font-size: 14px;
  color: #303133;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-input {
  width: 100%;
}

.form-input .el-input__inner {
  height: 40px;
  border: 1px solid #D9D9D9;
  border-radius: 6px;
  font-size: 14px;
  padding: 0 12px;
}

.form-input .el-input__inner:focus {
  border-color: #1E80FF;
  box-shadow: 0 0 0 2px rgba(30, 128, 255, 0.2);
}

.form-select {
  width: 100%;
}

.form-select .el-input__inner {
  height: 40px;
  border: 1px solid #D9D9D9;
  border-radius: 6px;
  font-size: 14px;
  padding: 0 12px;
}

.form-select .el-input__inner:focus {
  border-color: #1E80FF;
  box-shadow: 0 0 0 2px rgba(30, 128, 255, 0.2);
}

.form-actions {
  text-align: center;
}

.save-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 6px;
  background: #1E80FF;
  border-color: #1E80FF;
}

.save-btn:hover {
  background: #0F71E3;
  border-color: #0F71E3;
}

/* 我的关注样式 */
/* 收藏 Tab 切换样式 */
.collection-tabs {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e6eb;
}

.collection-tab-item {
  padding: 8px 20px;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s;
}

.collection-tab-item:hover {
  color: #0F6FE2;
  background: #f0f7ff;
}

.collection-tab-item.active {
  color: #0F6FE2;
  font-weight: 600;
  background: #f0f7ff;
}

/* 问答收藏列表样式 */
.qa-collections-list {
  margin-bottom: 20px;
}

.qa-card {
  background: #fff;
  border-radius: 10px;
  padding: 12px 14px 10px;
  box-shadow: 0 2px 8px rgba(31,35,41,0.06);
  margin-bottom: 16px;
  cursor: pointer;
  transition: all 0.3s;
}

.qa-card:hover {
  box-shadow: 0 4px 12px rgba(31,35,41,0.1);
}

.qa-card-header {
  display: flex;
  align-items: center;
}

.qa-head {
  flex: 1;
}

.qa-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.qa-card .name {
  color: #606266;
  font-weight: 600;
  font-size: 14px;
}

.qa-card .status {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  background: #EFF2F5;
  color: #8A8F99;
}

.qa-card .status.solved {
  background: #E6F4FF;
  color: #1E80FF;
}

.qa-card .status.unsolved {
  background: #EFF2F5;
  color: #8A8F99;
}

.qa-card .category {
  font-size: 12px;
  color: #F29E38;
}

.qa-card-right {
  color: #1E80FF;
  font-size: 12px;
}

.qa-card .avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 8px;
}

.qa-title {
  font-weight: 600;
  color: #333;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.qa-content {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.qa-card-image {
  margin: 10px 0;
  border-radius: 8px;
  overflow: hidden;
}

.qa-card-image img {
  width: 100%;
  max-height: 200px;
  object-fit: cover;
  border-radius: 8px;
  display: block;
}

.qa-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.qa-card-footer .bounty {
  color: #FF4800;
  font-size: 18px;
}

.qa-card-footer .right-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.qa-card-footer .cancel-collect-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #909399;
  cursor: pointer;
  font-size: 12px;
  transition: color 0.3s;
}

.qa-card-footer .cancel-collect-btn:hover {
  color: #FF4800;
}

.qa-card-footer .cancel-collect-icon {
  width: 14px;
  height: 14px;
}

/* 问答详情弹窗样式 */
.detail-body {
  max-height: 75vh;
  max-height: 75dvh;
  overflow-y: auto;
}

.detail-title {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 10px;
}

.detail-section {
  margin-top: 10px;
}

.section-title {
  font-weight: 600;
  color: #606266;
  margin-bottom: 8px;
  font-size: 18px;
}

.answer-item {
  padding: 10px 0;
  border-bottom: 1px solid #F2F3F5;
}

.answer-item:last-child {
  border-bottom: none;
}

.answer-user {
  display: flex;
  align-items: center;
  gap: 10px;
}

.answer-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}

.answer-name {
  color: #606266;
}

.answer-actions {
  display: flex;
  align-items: center;
  gap: 24px;
}

.adopt {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #909399;
  cursor: pointer;
}

.adopt.active {
  color: #1E80FF;
}

.action-icon {
  width: 16px;
  height: 16px;
}

.loading-text {
  text-align: center;
  padding: 20px;
  color: #909399;
}

.my-follows-section {
  max-width: 1200px;
}

.follows-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

/* 分页组件样式 */
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 32px;
  padding: 20px 0;
}

.follow-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border: 1px solid #E4E7ED;
}

.card-image {
  position: relative;
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.project-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-content {
  padding: 16px;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 空状态样式 */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #909399;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.empty-text {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #606266;
}

.empty-desc {
  font-size: 14px;
  color: #C0C4CC;
}

/* 造价问答中心（我的发布/我的回答） */
.qa-center-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.qa-go-publish-btn {
  font-weight: 600;
}

.qa-records-tabs {
  display: flex;
  align-items: center;
  gap: 24px;
  padding-bottom: 14px;
  border-bottom: 1px solid #f0f2f5;
  margin-bottom: 14px;
}

.qa-tab-item {
  position: relative;
  font-size: 16px;
  color: #9AA0A6;
  cursor: pointer;
}

.qa-tab-item.active {
  color: #1E80FF;
}

.qa-tab-item.active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -14px;
  height: 2px;
  background: #1E80FF;
}

.my-post-list { display: grid; gap: 16px; }
.my-post-item {
  border: 1px solid #EBEEF5;
  border-radius: 10px;
  background: #fff;
  padding: 16px;
  transition: box-shadow 0.2s ease;
}
.my-post-item:hover { box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06); }
.post-header { display: flex; justify-content: space-between; gap: 12px; align-items: center; margin-bottom: 8px; }
.post-title { font-size: 16px; font-weight: 600; color: #303133; }
.post-category { font-size: 12px; color: #1E80FF; background: #eef5ff; padding: 2px 8px; border-radius: 12px; }
.post-content { color: #606266; line-height: 1.7; margin-bottom: 10px; }
.post-images { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 10px; }
.post-image { width: 80px; height: 80px; border-radius: 6px; object-fit: cover; border: 1px solid #EBEEF5; }
.post-footer { display: flex; justify-content: space-between; align-items: center; }
.post-meta { display: flex; gap: 14px; font-size: 13px; color: #909399; }
.reward-amount { color: #F56C6C; font-weight: 600; }
.answer-count { color: #1E80FF; }

.my-tabs { display: flex; align-items: center; gap: 40px; padding: 6px 0 16px; }
.my-tab-item { position: relative; color: #9AA0A6; cursor: pointer; font-size: 16px; }
.my-tab-item.active { color: #1E80FF; }
.my-tab-item.active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -12px;
  height: 2px;
  background: #1E80FF;
}
.my-tab-content { padding-top: 8px; }

.my-answers-list { display: grid; gap: 14px; }
.answer-item-card { border: 1px solid #EBEEF5; border-radius: 10px; padding: 14px; background: #fff; }
.answer-card-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
.question-title { font-size: 15px; color: #303133; font-weight: 600; }
.adopt-status { font-size: 12px; color: #909399; background: #f4f4f5; border-radius: 12px; padding: 2px 10px; }
.adopt-status.adopted { color: #67C23A; background: #f0f9eb; }
.answer-content { color: #606266; line-height: 1.7; margin-bottom: 8px; }
.answer-images { display: flex; gap: 8px; flex-wrap: wrap; }
.answer-image { width: 72px; height: 72px; border-radius: 6px; object-fit: cover; border: 1px solid #EBEEF5; }

.income-card { background: linear-gradient(135deg, #1E80FF 0%, #53A5FF 100%); color: #fff; border-radius: 10px; padding: 18px; margin-bottom: 12px; }
.income-title { opacity: 0.9; margin-bottom: 6px; }
.income-total { font-size: 28px; font-weight: 700; }
.income-list-title { font-weight: 600; color: #303133; margin: 10px 0; }
.income-item { display: flex; align-items: center; justify-content: space-between; padding: 10px 4px; border-bottom: 1px solid #F2F3F5; }
.income-left { color: #606266; }
.income-name { margin-bottom: 2px; }
.income-question { color: #909399; font-size: 12px; }
.income-time { font-size: 12px; color: #A0A4AD; }
.income-amount { color: #1E80FF; font-weight: 600; }

.history-list { display: grid; gap: 12px; }
.history-item { border: 1px solid #EBEEF5; border-radius: 10px; padding: 12px 14px; }
.history-content { display: flex; flex-direction: column; gap: 8px; }
.history-title { color: #303133; font-weight: 600; }
.history-meta { display: flex; align-items: center; gap: 10px; }
.history-type { font-size: 12px; color: #909399; background: #f4f4f5; padding: 2px 8px; border-radius: 10px; }
.history-status { font-size: 12px; color: #909399; }
.history-status.adopted { color: #67C23A; }
.history-time { font-size: 12px; color: #A0A4AD; }

/* 问题反馈样式 */
.feedback-section {
  max-width: 600px;
}

.feedback-categories {
  margin-bottom: 24px;
}

.category-label {
  font-size: 16px;
  color: #303133;
  margin-bottom: 16px;
  font-weight: 600;
}

.category-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.category-btn {
  padding: 12px 24px;
  border: 1px solid #E4E7ED;
  border-radius: 20px;
  background: #F5F5F5;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  user-select: none;
}

.category-btn:hover {
  border-color: #1E80FF;
  background: #F0F9FF;
  color: #1E80FF;
}

.category-btn.active {
  background: #1E80FF;
  border-color: #1E80FF;
  color: #fff;
}

.feedback-notes {
  margin-bottom: 24px;
}

.notes-label {
  font-size: 16px;
  color: #303133;
  margin-bottom: 12px;
  font-weight: 600;
}

.notes-textarea {
  width: 100%;
}

.notes-textarea .el-textarea__inner {
  border: 1px solid #D9D9D9;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.5;
  padding: 12px;
  resize: vertical;
}

.notes-textarea .el-textarea__inner:focus {
  border-color: #1E80FF;
  box-shadow: 0 0 0 2px rgba(30, 128, 255, 0.2);
}

.feedback-upload {
  margin-bottom: 32px;
}

.upload-label {
  font-size: 16px;
  color: #303133;
  margin-bottom: 12px;
  font-weight: 600;
}

.upload-area {
  display: flex;
  justify-content: flex-start;
}

.upload-placeholder {
  width: 80px;
  height: 80px;
  background: #F5F5F5;
  border: 1px solid #D9D9D9;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
}

.upload-placeholder:hover {
  border-color: #1E80FF;
  background: #F0F9FF;
}

.upload-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.image-preview {
  position: relative;
  width: 100%;
  height: 100%;
}

.preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
  border-radius: 6px;
}

.upload-placeholder:hover .image-overlay {
  opacity: 1;
}

.change-text {
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}

.feedback-actions {
  text-align: center;
}

.submit-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  background: #1E80FF;
  border-color: #1E80FF;
}

.submit-btn:hover {
  background: #0F71E3;
  border-color: #0F71E3;
}

.submit-btn:disabled {
  background: #C0C4CC;
  border-color: #C0C4CC;
  color: #fff;
}

/* 我的下载样式 */
.my-downloads-section {
  max-width: 1000px;
}

.downloads-list {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.download-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #F0F0F0;
  transition: background-color 0.3s;
}

.download-item:last-child {
  border-bottom: none;
}

.download-item:hover {
  background: #F8F9FA;
}

.file-info {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.file-icon {
  width: 40px;
  height: 40px;
  margin-right: 12px;
  flex-shrink: 0;
}

.type-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.file-details {
  flex: 1;
  min-width: 0;
}

.file-name {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-meta {
  display: flex;
  gap: 12px;
  font-size: 12px;
  color: #909399;
}

.file-size {
  color: #666;
}

.file-date {
  color: #909399;
}

/* 模板选择弹窗样式 */
.template-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.template-dialog {
  background: #fff;
  border-radius: 12px;
  width: 600px;
  max-width: 92vw;
  max-height: var(--dialog-body-max-height, 75vh);
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #E4E7ED;
}

.dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin: 0;
}

.dialog-content {
  max-height: 400px;
  overflow-y: auto;
  padding: 20px 24px;
}

.empty-templates {
  text-align: center;
  padding: 40px 20px;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.empty-text {
  font-size: 16px;
  color: #606266;
  margin-bottom: 8px;
}

.empty-desc {
  font-size: 14px;
  color: #909399;
}

.template-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.template-item {
  display: flex;
  align-items: center;
  padding: 16px;
  border: 1px solid #E4E7ED;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.template-item:hover {
  border-color: #1E80FF;
  background: #F0F7FF;
}

.template-item.active {
  border-color: #1E80FF;
  background: #F0F7FF;
}

.template-radio {
  margin-right: 16px;
}

.template-radio-input {
  margin: 0;
}

.template-info {
  flex: 1;
}

.template-name {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 4px;
}

.template-company {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
}

.template-details {
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #909399;
}

.template-type {
  background: #E4E7ED;
  padding: 2px 8px;
  border-radius: 4px;
}

.template-tax {
  color: #606266;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 24px;
  border-top: 1px solid #E4E7ED;
}

/* 全选样式 */
.select-all-checkbox {
  font-weight: 500;
}

.order-checkbox {
  margin: 0;
}

/* 申诉表单样式 */
.engineer-appeal-section {
  max-width: 800px;
}

.appeal-form {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
}

.appeal-form .form-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 24px;
  text-align: center;
}

.appeal-form .form-group {
  margin-bottom: 24px;
}

.appeal-textarea {
  width: 100%;
}

.appeal-textarea .el-textarea__inner {
  border-radius: 8px;
  border: 1px solid #E4E7ED;
  font-size: 14px;
  padding: 16px;
  resize: none;
  transition: border-color 0.3s;
}

.appeal-textarea .el-textarea__inner:focus {
  border-color: #1E80FF;
}

.appeal-form .upload-label {
  font-size: 14px;
  color: #303133;
  margin-bottom: 12px;
  font-weight: 500;
}

.appeal-form .upload-area {
  display: flex;
  justify-content: flex-start;
}

.appeal-form .upload-placeholder {
  width: 100px;
  height: 100px;
  border: 2px dashed #E4E7ED;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  background: #FAFAFA;
}

.appeal-form .upload-placeholder:hover {
  border-color: #1E80FF;
  background: #F0F7FF;
}

.appeal-form .upload-icon {
  width: 40px;
  height: 40px;
  opacity: 0.6;
}

.appeal-form .image-preview {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
}

.appeal-form .preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.appeal-form .image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
}

.appeal-form .image-preview:hover .image-overlay {
  opacity: 1;
}

.appeal-form .change-text {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
}

.appeal-form .form-actions {
  text-align: center;
  margin-top: 32px;
}

.appeal-form .submit-btn {
  width: 200px;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  background: #1E80FF;
  border-color: #1E80FF;
}

.appeal-form .submit-btn:hover {
  background: #0F71E3;
  border-color: #0F71E3;
}

.appeal-form .submit-btn:disabled {
  background: #C0C4CC;
  border-color: #C0C4CC;
  cursor: not-allowed;
}

/* 案例管理样式 */
.case-management-section {
  max-width: 100%;
}

.case-management-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding: 0 4px;
}

.case-categories {
  display: flex;
  gap: 24px;
}

.case-categories .category-item {
  font-size: 16px;
  color: #606266;
  cursor: pointer;
  padding: 8px 0;
  border-bottom: 2px solid transparent;
  transition: all 0.3s;
}

.case-categories .category-item.active {
  color: #1E80FF;
  border-bottom-color: #1E80FF;
  font-weight: 500;
}

.case-actions {
  display: flex;
  gap: 12px;
}

.upload-case-btn {
  height: 36px;
  padding: 0 20px;
  font-size: 14px;
  border-radius: 6px;
}

.delete-case-btn {
  height: 36px;
  padding: 0 20px;
  font-size: 14px;
  border-radius: 6px;
}

.case-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 32px;
}

.case-item {
  cursor: pointer;
  transition: transform 0.2s;
}

.case-item:hover {
  transform: translateY(-2px);
}

.case-image {
  position: relative;
  width: 100%;
  height: 200px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 12px;
}

.case-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.case-checkbox {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.case-checkbox.selected {
  background: #1E80FF;
  color: #fff;
}

.case-checkbox i {
  font-size: 14px;
  font-weight: bold;
}

.case-title {
  font-size: 14px;
  color: #303133;
  line-height: 1.4;
  text-align: center;
  padding: 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.case-pagination {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.case-delete-action {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.delete-immediately-btn {
  width: 200px;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  background: #1E80FF;
  border-color: #1E80FF;
}

.delete-immediately-btn:hover {
  background: #0F71E3;
  border-color: #0F71E3;
}

/* 造价师信息样式 */
.engineer-info-form {
  padding: 24px;
  background: #fff;
  border-radius: 8px;
}

.engineer-info-form .form-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 24px;
}

.engineer-basic-info {
  background: #F8F9FA;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 24px;
}

.engineer-basic-info .info-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.engineer-basic-info .info-item:last-child {
  margin-bottom: 0;
}

.engineer-basic-info .info-label {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
  min-width: 80px;
}

.engineer-basic-info .info-value {
  font-size: 14px;
  color: #303133;
}

.engineer-info-form .form-group {
  margin-bottom: 24px;
}

.engineer-info-form .form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #606266;
  margin-bottom: 8px;
}

.engineer-avatar-editor {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.engineer-avatar-preview {
  width: 150px;
  height: 200px;
  border-radius: 20px;
  object-fit: cover;
  border: 1px solid #E4E7ED;
  background: #f5f7fa;
}

.engineer-avatar-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.avatar-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}

.engineer-textarea {
  width: 100%;
}

.engineer-input {
  width: 100%;
}

.engineer-select {
  width: 100%;
}

.honor-wall-section {
  margin-top: 8px;
}

.honor-wall-section .upload-area {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.honor-image-item {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #E4E7ED;
}

.honor-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.honor-image-item .image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
}

.honor-image-item:hover .image-overlay {
  opacity: 1;
}

.remove-btn {
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  background: #F56C6C;
  border-radius: 4px;
  cursor: pointer;
}

.upload-placeholder {
  width: 120px;
  height: 120px;
  border: 2px dashed #DCDFE6;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.3s;
}

.upload-placeholder:hover {
  border-color: #1E80FF;
}

.upload-placeholder .upload-icon {
  width: 32px;
  height: 32px;
  margin-bottom: 8px;
}

.upload-text {
  font-size: 12px;
  color: #909399;
}

.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
}

.engineer-info-form .form-actions {
  margin-top: 32px;
  text-align: center;
}

.engineer-info-form .submit-btn {
  width: 200px;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  background: #1E80FF;
  border-color: #1E80FF;
}

.engineer-info-form .submit-btn:hover {
  background: #0F71E3;
  border-color: #0F71E3;
}

/* 咨询样式（覆盖页面全局 .user-info 侧栏居中布局） */
.consulting-container .user-info {
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0;
  margin-bottom: 4px;
  text-align: left;
}

.consulting-container .conversation-header .user-info {
  margin-bottom: 0;
}

.consulting-container .user-info .nickname,
.consulting-container .latest-message {
  text-align: left;
}

.consulting-container {
  height: calc(100vh - var(--navbar-total-height, 80px) - 120px);
  height: calc(100dvh - var(--navbar-total-height, 80px) - 120px);
  padding: 20px;
}

.consulting-wrapper {
  display: flex;
  height: 100%;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

/* 左侧留言列表 */
.message-list-panel {
  width: 300px;
  min-width: 0;
  flex-shrink: 0;
  border-right: 1px solid #E4E7ED;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.panel-header {
  padding: 20px;
  border-bottom: 1px solid #E4E7ED;
  background: #F8F9FA;
}

.panel-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.message-list {
  flex: 1;
  overflow-y: auto;
}

.message-item {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  cursor: pointer;
  border-bottom: 1px solid #F2F3F5;
  transition: background-color 0.3s;
  min-width: 0;
  overflow: hidden;
}

.message-item:hover {
  background: #F8F9FA;
}

.message-item.active {
  background: #E6F7FF;
  border-right: 3px solid #1890FF;
}

.avatar-container {
  position: relative;
  margin-right: 12px;
  flex-shrink: 0;
}

.user-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
}

.unread-badge {
  background: #FF4D4F;
  color: #fff;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
}

.message-content {
  flex: 1;
  min-width: 0;
  text-align: left;
}

.consulting-container .message-list .user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  width: 100%;
  overflow: hidden;
}

.message-list .user-info .nickname {
  display: block;
  flex: 1;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.message-list .user-info .message-time {
  flex-shrink: 0;
  white-space: nowrap;
}

.nickname {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.message-time {
  font-size: 12px;
  color: #909399;
  flex-shrink: 0;
}

.message-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.latest-message {
  font-size: 13px;
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}

.unread-badge {
  background: #FF4D4F;
  color: #fff;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  flex-shrink: 0;
}

/* 右侧对话详情 */
.conversation-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.conversation-header {
  padding: 20px;
  border-bottom: 1px solid #E4E7ED;
  background: #F8F9FA;
}

.conversation-header .user-info {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  margin-right: 12px;
}

.conversation-header .user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 12px;
}

.conversation-header .nickname {
  display: block;
  flex: 1;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.conversation-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-actions {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

/* 收费回复弹窗样式 */
.charge-reply-form {
  padding: 20px 0;
}

.charge-reply-form .form-group {
  margin-bottom: 24px;
}

.charge-reply-form .form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #606266;
  margin-bottom: 8px;
}

/* 图片上传样式 - 同步uploadCase */
.image-upload-section {
  width: 100%;
}

.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-bottom: 12px;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.image-item {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
}

.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
}

.image-item:hover .image-overlay {
  opacity: 1;
}

.upload-placeholder {
  width: 100px;
  height: 100px;
  border: 2px dashed #E4E7ED;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  background: #FAFAFA;
}

.upload-placeholder:hover {
  border-color: #1E80FF;
  background: #F0F7FF;
}

.upload-icon {
  font-size: 24px;
  color: #C0C4CC;
  margin-bottom: 4px;
}

.upload-text {
  font-size: 12px;
  color: #909399;
}

/* 文件上传样式 - 同步uploadCase */
.file-upload-section {
  width: 100%;
}

.file-list {
  margin-bottom: 12px;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: #F5F7FA;
  border-radius: 8px;
  margin-bottom: 8px;
}

.file-icon {
  font-size: 16px;
  color: #1E80FF;
}

.file-name {
  flex: 1;
  font-size: 14px;
  color: #303133;
}

.file-upload-area {
  padding: 20px;
  border: 2px dashed #E4E7ED;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  background: #FAFAFA;
}

.file-upload-area:hover {
  border-color: #1E80FF;
  background: #F0F7FF;
}

.file-upload-icon {
  font-size: 32px;
  color: #C0C4CC;
  margin-bottom: 8px;
}

.file-upload-text {
  font-size: 14px;
  color: #606266;
  margin-bottom: 4px;
}

.file-upload-tip {
  font-size: 12px;
  color: #909399;
}

.dialog-footer {
  text-align: right;
}

.dialog-footer .el-button {
  margin-left: 12px;
}

.conversation-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  background: #FAFAFA;
}

.empty-message {
  text-align: center;
  padding: 60px 20px;
  color: #909399;
}

.loading-more {
  text-align: center;
  padding: 20px;
  color: #909399;
  font-size: 14px;
}

.loading-more i {
  margin-right: 8px;
  animation: rotating 2s linear infinite;
}

.load-more-tip {
  text-align: center;
  color: #0f70e2;
  padding: 12px;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
  transition: color 0.3s ease;
  border-bottom: 1px solid rgba(17, 17, 17, 0.1);
  margin-bottom: 10px;
}

.load-more-tip:hover {
  color: #0c5bb8;
}

.load-more-tip:active {
  opacity: 0.7;
}

@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.messages-container {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.msg {
  display: flex;
  align-items: flex-start;
}

.msg.right {
  flex-direction: row-reverse;
}

.msg .avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin: 0 8px;
  object-fit: cover;
}

.bubble {
  background: #EEF4FB;
  padding: 10px 12px;
  border-radius: 8px;
  max-width: 70%;
}

.bubble.primary {
  background: #0f70e2;
  color: #fff;
}

.bubble .message-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.bubble .sender-name {
  font-size: 12px;
  font-weight: 500;
  opacity: 0.8;
}

.bubble .paid-badge {
  background: #FF4D4F;
  color: #fff;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  font-weight: 500;
}

.bubble .amount-badge {
  background: #52C41A;
  color: #fff;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  font-weight: 500;
}

.bubble .message-text {
  font-size: 14px;
  line-height: 1.4;
  word-wrap: break-word;
}

/* 消息内容样式 */
.message-image {
  margin-bottom: 8px;
}

.message-image .message-img {
  max-width: 300px;
  max-height: 300px;
  border-radius: 8px;
  cursor: pointer;
  display: block;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.message-image .message-img:hover {
  transform: scale(1.02);
}

.message-file {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  margin-bottom: 8px;
}

.message-file .file-info {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.message-file .file-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.message-file .file-name {
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.message-file .file-link {
  color: #0f70e2;
  text-decoration: underline;
  font-size: 14px;
  margin-left: 12px;
  flex-shrink: 0;
  font-weight: 500;
  transition: color 0.3s ease;
}

.message-file .file-link:hover {
  color: #0c5bb8;
}

.bubble.primary .message-file {
  background: rgba(255, 255, 255, 0.15);
}

.bubble.primary .message-file .file-link {
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 8px;
  border-radius: 4px;
  text-decoration: none;
}

.bubble.primary .message-file .file-link:hover {
  background: rgba(255, 255, 255, 0.3);
  color: #fff;
}

.charge-info {
  margin-top: 12px;
  padding: 12px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e5e6eb;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.charge-text {
  font-size: 14px;
  color: #333;
  line-height: 1.4;
  word-wrap: break-word;
  word-break: break-all;
}

.charge-text .amount {
  color: #ff4757;
  font-weight: bold;
}

.charge-btn {
  background: #0f70e2;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  align-self: flex-end;
  white-space: nowrap;
  flex-shrink: 0;
}

.charge-btn:hover {
  background: #0c5bb8;
}

.bubble.primary .charge-info {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.bubble.primary .charge-text {
  color: #fff;
}

.other-message .message-text {
  background: #fff;
  color: #303133;
  border: 1px solid #E4E7ED;
  border-bottom-left-radius: 4px;
}

/* 消息输入区域 */
.message-input {
  padding: 20px;
  border-top: 1px solid #E4E7ED;
  background: #fff;
}

.consulting-upload-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.consulting-upload-buttons .consulting-upload-icon {
  width: 30px;
  height: 30px;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.consulting-upload-buttons .consulting-upload-icon:hover {
  opacity: 0.7;
}

.input-tools {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}

.tool-icon {
  font-size: 18px;
  color: #C0C4CC;
  cursor: pointer;
  transition: color 0.3s;
}

.tool-icon:hover {
  color: #606266;
}

.input-area {
  display: flex;
  gap: 12px;
  align-items: flex-end;
}

.input-area .el-textarea {
  flex: 1;
}

.input-area .el-button {
  height: 40px;
  padding: 0 20px;
}

/* 滚动条样式 */
.message-list::-webkit-scrollbar,
.conversation-content::-webkit-scrollbar {
  width: 6px;
}

.message-list::-webkit-scrollbar-track,
.conversation-content::-webkit-scrollbar-track {
  background: #F5F5F5;
}

.message-list::-webkit-scrollbar-thumb,
.conversation-content::-webkit-scrollbar-thumb {
  background: #C0C4CC;
  border-radius: 3px;
}

.message-list::-webkit-scrollbar-thumb:hover,
.conversation-content::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

/* 个人资料 - 资质认证入口（跳转独立页） */
.profile-cert-entries {
  margin-top: 28px;
  padding-top: 24px;
  border-top: 1px solid #ebeef5;
}

.profile-cert-entry-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.profile-cert-entry-card {
  flex: 1;
  min-width: 240px;
  max-width: 400px;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  border-radius: 10px;
  border: 1px solid #e4e7ed;
  background: #fafbfc;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.profile-cert-entry-card:hover {
  border-color: #1e80ff;
  background: #f5faff;
  box-shadow: 0 4px 12px rgba(30, 128, 255, 0.12);
}

.profile-cert-entry-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: linear-gradient(135deg, #1e80ff 0%, #0f71e3 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.profile-cert-entry-icon-wrap.supplier {
  background: linear-gradient(135deg, #67c23a 0%, #529b2e 100%);
}

.profile-cert-entry-icon {
  font-size: 22px;
  color: #fff;
}

.profile-cert-entry-text {
  flex: 1;
  min-width: 0;
}

.profile-cert-entry-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 4px;
}

.profile-cert-entry-desc {
  font-size: 13px;
  color: #909399;
  line-height: 1.4;
}

.profile-cert-entry-arrow {
  font-size: 16px;
  color: #c0c4cc;
  flex-shrink: 0;
}

.profile-cert-entry-card:hover .profile-cert-entry-arrow {
  color: #1e80ff;
}

</style>
